var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHybridCarLandingImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 900.76 498.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18{fill:none;}.cls-19{strokeWidth:.93px;}.cls-19,.cls-2,.cls-3,.cls-20,.cls-21,.cls-4,.cls-22,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-23,.cls-24,.cls-17,.cls-18{stroke-miterlimit:10;}.cls-19,.cls-20,.cls-21,.cls-22{fill:#a1a8aa;stroke:gray;}.cls-25{fill:url(#linear-gradient);}.cls-26{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_27);}.cls-2,.cls-3,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14{strokeWidth:1.08px;}.cls-2,.cls-5,.cls-24,.cls-17{stroke:#12140d;}.cls-3{stroke:#2f302c;}.cls-27{clip-path:url(#clippath);}.cls-28{fill:url(#_649);}.cls-29{fill:url(#_652);}.cls-20{strokeWidth:.61px;}.cls-30{fill:url(#_649-3);opacity:.76;}.cls-31{fill:url(#_649-8);}.cls-31,.cls-32{opacity:.53;}.cls-32{fill:url(#_649-9);}.cls-33{fill:#f3f3f7;}.cls-34{fill:#f99e6f;}.cls-35{fill:#030f3d;}.cls-36{fill:#f0f2f1;}.cls-37{fill:#eaebef;}.cls-38{fill:#e9edf3;}.cls-39{fill:#ff1920;}.cls-40{fill:#e8ecf2;}.cls-41{fill:#fff;}.cls-42{fill:#feffff;}.cls-43{fill:#e5e7eb;}.cls-44{fill:#eceef0;}.cls-45{fill:#979b9e;}.cls-46{fill:#9fa8b3;}.cls-47{fill:#93979a;}.cls-48{fill:#8c9294;}.cls-49{fill:#666969;}.cls-50{fill:#323333;}.cls-51{fill:#333;}.cls-52{fill:#b7c2cf;}.cls-53{fill:#abb0b5;}.cls-54{fill:#a6a8b2;}.cls-55{fill:#a6a7b0;}.cls-56{fill:#bcc1cb;}.cls-57{fill:#c0bfcb;}.cls-58{fill:#d0d1da;}.cls-59{fill:#cbcbcb;}.cls-60{fill:#d1d3db;}.cls-61{fill:#dbdfe2;}.cls-62{fill:#e0e4ea;}.cls-63{fill:#252623;}.cls-64{fill:#222;}.cls-65{fill:#434444;}.cls-66{fill:#12140d;}.cls-67{fill:#1d1d1d;}.cls-68{fill:#191a17;}.cls-69{fill:#3e3e3e;}.cls-70{fill:#1a1a1a;}.cls-71{fill:#9b4949;}.cls-72{fill:#88939e;}.cls-73{fill:#878890;}.cls-74{fill:gray;}.cls-75{fill:#2a2b28;}.cls-76{fill:#484848;}.cls-77,.cls-24{fill:#2f302c;}.cls-78{fill:#74818d;}.cls-79{fill:#52544d;}.cls-80{fill:#505d69;}.cls-81{fill:url(#_649-10);opacity:.45;}.cls-82{fill:url(#_649-7);opacity:.75;}.cls-83{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_27-2);}.cls-21{strokeWidth:1.02px;}.cls-84{fill:url(#linear-gradient-111);}.cls-85{fill:url(#linear-gradient-110);}.cls-86{fill:url(#linear-gradient-113);}.cls-87{fill:url(#linear-gradient-115);}.cls-88{fill:url(#linear-gradient-106);}.cls-89{fill:url(#linear-gradient-107);}.cls-90{fill:url(#linear-gradient-108);}.cls-91{fill:url(#linear-gradient-103);}.cls-92{fill:url(#linear-gradient-102);}.cls-93{fill:url(#linear-gradient-105);}.cls-94{fill:url(#linear-gradient-101);}.cls-95{fill:url(#linear-gradient-100);}.cls-4{stroke:#001231;strokeWidth:.54px;}.cls-4,.cls-15,.cls-16,.cls-23,.cls-96{opacity:.4;}.cls-97{fill:url(#linear-gradient-109);}.cls-97,.cls-98,.cls-99,.cls-100,.cls-15,.cls-101,.cls-18{stroke:#697273;}.cls-98{fill:url(#linear-gradient-104);}.cls-99{fill:url(#linear-gradient-112);}.cls-100{fill:url(#linear-gradient-114);}.cls-22{strokeWidth:.88px;}.cls-5,.cls-6,.cls-15,.cls-16,.cls-23,.cls-18{strokeWidth:.81px;}.cls-6,.cls-16{stroke:#0d316e;}.cls-102{fill:url(#linear-gradient-8);}.cls-103{fill:url(#linear-gradient-9);}.cls-104{fill:url(#linear-gradient-3);}.cls-105{fill:url(#linear-gradient-4);}.cls-106{fill:url(#linear-gradient-6);}.cls-107{fill:url(#linear-gradient-5);}.cls-108{fill:url(#linear-gradient-80);}.cls-108,.cls-109,.cls-18{opacity:.3;}.cls-110{opacity:.2;}.cls-111{fill:url(#linear-gradient-36);}.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119{opacity:.8;}.cls-112{fill:url(#linear-gradient-37);}.cls-113{fill:url(#linear-gradient-74);}.cls-114{fill:url(#linear-gradient-75);}.cls-115{fill:url(#linear-gradient-70);}.cls-116{fill:url(#linear-gradient-51);}.cls-7{stroke:url(#linear-gradient-58);}.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14{stroke-dasharray:0 6.46;}.cls-8{stroke:url(#linear-gradient-57);}.cls-9{stroke:url(#linear-gradient-56);}.cls-10{stroke:url(#linear-gradient-60);}.cls-11{stroke:url(#linear-gradient-63);}.cls-12{stroke:url(#linear-gradient-62);}.cls-13{stroke:url(#linear-gradient-61);}.cls-14{stroke:url(#linear-gradient-59);}.cls-120{fill:url(#linear-gradient-55);}.cls-121{fill:url(#linear-gradient-53);}.cls-122{fill:url(#linear-gradient-54);}.cls-123{fill:url(#linear-gradient-52);}.cls-124{fill:url(#linear-gradient-50);}.cls-125{fill:url(#linear-gradient-77);}.cls-126{fill:url(#linear-gradient-78);}.cls-127{fill:url(#linear-gradient-79);}.cls-128{fill:url(#linear-gradient-76);}.cls-129{fill:url(#linear-gradient-71);}.cls-130{fill:url(#linear-gradient-72);}.cls-131{fill:url(#linear-gradient-73);}.cls-132{fill:url(#linear-gradient-68);}.cls-133{fill:url(#linear-gradient-67);}.cls-134{fill:url(#linear-gradient-69);}.cls-135{fill:url(#linear-gradient-64);}.cls-136{fill:url(#linear-gradient-66);}.cls-137{fill:url(#linear-gradient-65);}.cls-138{fill:url(#linear-gradient-98);}.cls-139{fill:url(#linear-gradient-91);}.cls-140{fill:url(#linear-gradient-95);}.cls-141{fill:url(#linear-gradient-99);}.cls-142{fill:url(#linear-gradient-96);}.cls-143{fill:url(#linear-gradient-97);}.cls-144{fill:url(#linear-gradient-94);}.cls-145{fill:url(#linear-gradient-92);}.cls-146{fill:url(#linear-gradient-93);}.cls-147{fill:url(#linear-gradient-90);}.cls-148{fill:url(#linear-gradient-81);}.cls-149{fill:url(#linear-gradient-88);}.cls-150{fill:url(#linear-gradient-87);}.cls-151{fill:url(#linear-gradient-86);}.cls-152{fill:url(#linear-gradient-85);}.cls-153{fill:url(#linear-gradient-84);}.cls-154{fill:url(#linear-gradient-83);}.cls-155{fill:url(#linear-gradient-82);}.cls-156{fill:url(#linear-gradient-41);}.cls-157{fill:url(#linear-gradient-40);}.cls-158{fill:url(#linear-gradient-43);}.cls-159{fill:url(#linear-gradient-42);}.cls-160{fill:url(#linear-gradient-45);}.cls-161{fill:url(#linear-gradient-46);}.cls-162{fill:url(#linear-gradient-44);}.cls-163{fill:url(#linear-gradient-49);}.cls-164{fill:url(#linear-gradient-47);}.cls-165{fill:url(#linear-gradient-48);}.cls-166{fill:url(#linear-gradient-14);}.cls-167{fill:url(#linear-gradient-18);}.cls-168{fill:url(#linear-gradient-22);}.cls-169{fill:url(#linear-gradient-20);}.cls-170{fill:url(#linear-gradient-21);}.cls-171{fill:url(#linear-gradient-23);}.cls-172{fill:url(#linear-gradient-15);}.cls-173{fill:url(#linear-gradient-19);}.cls-174{fill:url(#linear-gradient-16);}.cls-175{fill:url(#linear-gradient-17);}.cls-176{fill:url(#linear-gradient-13);}.cls-177{fill:url(#linear-gradient-12);}.cls-178{fill:url(#linear-gradient-10);}.cls-179{fill:url(#linear-gradient-11);}.cls-180{fill:url(#linear-gradient-27);}.cls-181{fill:url(#linear-gradient-24);}.cls-182{fill:url(#linear-gradient-26);}.cls-183{fill:url(#linear-gradient-38);}.cls-184{fill:url(#linear-gradient-35);}.cls-185{fill:url(#linear-gradient-34);}.cls-186{fill:url(#linear-gradient-39);}.cls-187{fill:url(#linear-gradient-25);}.cls-188{fill:url(#linear-gradient-28);}.cls-189{fill:url(#linear-gradient-29);}.cls-190{fill:url(#linear-gradient-33);}.cls-191{fill:url(#linear-gradient-30);}.cls-192{fill:url(#linear-gradient-32);}.cls-193{fill:url(#linear-gradient-31);}.cls-23{fill:#acacac;stroke:#6f6f6f;}.cls-117{fill:url(#linear-gradient-2);}.cls-118{fill:url(#linear-gradient-7);}.cls-194{fill:url(#_649-4);}.cls-195{fill:url(#_649-5);}.cls-196{fill:url(#_649-6);}.cls-197{fill:url(#_649-2);}.cls-198{fill:url(#_652-2);}.cls-199{fill:url(#_652-4);}.cls-200{fill:url(#_652-3);}.cls-201{fill:url(#_652-6);}.cls-202{fill:url(#_652-5);}.cls-101{fill:url(#linear-gradient-89);}.cls-119{fill:#56697c;}.cls-109{fill:#6e6e6e;}.cls-24{strokeWidth:1.45px;}.cls-96{fill:#909aa6;}.cls-17{strokeWidth:.98px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 442.72,
    y1: 352.28,
    x2: 442.72,
    y2: -23.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#e3e7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#c8dae9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9dc4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#61a5dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#157ed5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0073d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_652",
    x1: 193.99,
    y1: 179.11,
    x2: 198.27,
    y2: 97.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9fdaf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#aadbf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cde0f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_652-2",
    x1: 195.94,
    y1: 63.85,
    x2: 297,
    y2: 63.85,
    xlinkHref: "#_652"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_652-3",
    x1: 95.13,
    y1: 176.62,
    x2: 97.94,
    y2: 123.09,
    xlinkHref: "#_652"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_652-4",
    x1: 10283.62,
    y1: 140.45,
    x2: 10482.48,
    y2: 140.45,
    gradientTransform: "translate(11043) rotate(-180) scale(1 -1)",
    xlinkHref: "#_652"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_649",
    x1: 505.76,
    y1: 79.03,
    x2: 506.49,
    y2: 65.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8dde9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cde0f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_652-5",
    x1: 530.24,
    y1: 101.89,
    x2: 672.95,
    y2: 101.89,
    xlinkHref: "#_652"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_649-2",
    x1: 13638.19,
    y1: -5385.46,
    x2: 13639.59,
    y2: -5412.07,
    gradientTransform: "translate(14100.98 -5979.66) rotate(134.04) scale(1 -1)",
    xlinkHref: "#_649"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_649-3",
    x1: 12710.42,
    y1: 545.06,
    x2: 12634.43,
    y2: 478.91,
    gradientTransform: "translate(13014.96 571.76) rotate(-175.74) scale(1 -1)",
    xlinkHref: "#_649"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_649-4",
    x1: 542.01,
    y1: 202.93,
    x2: 511.74,
    y2: 176.57,
    xlinkHref: "#_649"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_649-5",
    x1: 219.16,
    y1: -301.88,
    x2: 177.29,
    y2: -338.34,
    gradientTransform: "translate(269.6 474.04) rotate(-4.8)",
    xlinkHref: "#_649"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_649-6",
    x1: 448.12,
    y1: 240.96,
    x2: 367.3,
    y2: 170.6,
    xlinkHref: "#_649"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_649-7",
    x1: 659.36,
    y1: 264.95,
    x2: 534.02,
    y2: 155.85,
    xlinkHref: "#_649"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_649-8",
    x1: 525.64,
    y1: 240.16,
    x2: 861.96,
    y2: 240.16,
    xlinkHref: "#_649"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_649-9",
    x1: 106.18,
    y1: 218.13,
    x2: 433.39,
    y2: 218.13,
    xlinkHref: "#_649"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_649-10",
    x1: 59.21,
    y1: 234.3,
    x2: 260.22,
    y2: 234.3,
    xlinkHref: "#_649"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.75,
    y: 16.06,
    width: 888.01,
    height: 368.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_652-6",
    x1: 14099.49,
    y1: -4212.67,
    x2: 14306.97,
    y2: -4212.67,
    gradientTransform: "translate(14750.16 -4849.36) rotate(143.6) scale(1 -1)",
    xlinkHref: "#_652"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 185.18,
    y1: 284.49,
    x2: 187.34,
    y2: 238.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3f74a1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#4178a7",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#4885b9",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#529ad5",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#559fdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5ddff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 81.6,
    y1: 263.48,
    x2: 282.86,
    y2: 263.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d316e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#356496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#67a5c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7bbfde"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 8.2,
    y1: 317.32,
    x2: 18.06,
    y2: 317.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 11.36,
    y1: 334.51,
    x2: 102.38,
    y2: 334.51,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 93.52,
    y1: 339.18,
    x2: 120.42,
    y2: 271.76,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 106.16,
    y1: 283.73,
    x2: 110.87,
    y2: 313.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#c6c9cc",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7e9cb5",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#507fa6",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3f74a1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0,
    y1: 344.79,
    x2: 12.53,
    y2: 344.79,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0,
    y1: 334.9,
    x2: 15.06,
    y2: 334.9,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 75.95,
    y1: 325.85,
    x2: 118.09,
    y2: 325.85,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 80.82,
    y1: 327.99,
    x2: 164.19,
    y2: 327.99,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 159.03,
    y1: 333.77,
    x2: 73.75,
    y2: 353.52,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 85.94,
    y1: 313.29,
    x2: 163.1,
    y2: 313.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cacaca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 85.94,
    y1: 320.41,
    x2: 138.44,
    y2: 320.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cacaca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 136.8,
    y1: 312.9,
    x2: 163.02,
    y2: 312.9,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 123.23,
    y1: 315.45,
    x2: 131.19,
    y2: 315.45,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 86.65,
    y1: 311.89,
    x2: 159.81,
    y2: 311.89,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 99.37,
    y1: 352.74,
    x2: 136.8,
    y2: 352.74,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 330.45,
    y1: 290.85,
    x2: 337.78,
    y2: 362.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7bbfde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#67a5c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#356496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d316e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 304.05,
    y1: 334.26,
    x2: 304.75,
    y2: 363.1,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 303.71,
    y1: 351.55,
    x2: 303.33,
    y2: 341.64,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 329.05,
    y1: 311.51,
    x2: 327.22,
    y2: 283.74,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 308.33,
    y1: 302.53,
    x2: 307.86,
    y2: 294.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7bbfde",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#619ec4",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#204a82",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d316e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 307.81,
    y1: 293.13,
    x2: 307.65,
    y2: 290.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7bbfde",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#75b6d4",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#67a0bc",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5889a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 425.23,
    y1: 269.97,
    x2: 237.06,
    y2: 315.15,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 342.04,
    y1: 272.72,
    x2: 344.2,
    y2: 237.5,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 374.54,
    y1: 214.3,
    x2: 379.87,
    y2: 261.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#bcbfbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88908d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 410.45,
    y1: 242.7,
    x2: 101.09,
    y2: 289.79,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 328.16,
    y1: 215.98,
    x2: 333.68,
    y2: 265.13,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 249.17,
    y1: 272.76,
    x2: 211.48,
    y2: 294.21,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 323.25,
    y1: -20.92,
    x2: 318.16,
    y2: -27.7,
    gradientTransform: "translate(-79.23 316.2) rotate(-2.08)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 169.34,
    y1: 327.11,
    x2: 206.76,
    y2: 277.57,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 156.08,
    y1: 399.85,
    x2: 175.83,
    y2: 312.47,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 186.43,
    y1: 355.33,
    x2: 222.89,
    y2: 307.07,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 197.54,
    y1: 317.73,
    x2: 229.62,
    y2: 365.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5c8ea6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#497796",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#183f6d",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 284.28,
    y1: 289.43,
    x2: 281.52,
    y2: 234.81,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 358.23,
    y1: 285.7,
    x2: 355.47,
    y2: 231.08,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 420.46,
    y1: 280.98,
    x2: 432.85,
    y2: 289.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#646d78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#79868a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#808e90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 422.85,
    y1: 306.42,
    x2: 434.1,
    y2: 306.42,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 397.8,
    y1: 254.11,
    x2: 429.49,
    y2: 275.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#12140d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#222826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354144"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 442.54,
    y1: 319.64,
    x2: 431.26,
    y2: 321.13,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 136.48,
    y1: 354.63,
    x2: 157.26,
    y2: 354.63,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 378.69,
    y1: 293.95,
    x2: 378.8,
    y2: 306.9,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -7325.51,
    y1: -57.89,
    x2: -7310.13,
    y2: -57.89,
    gradientTransform: "translate(7694.26 92.23) rotate(-2.08)",
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 312.95,
    y1: 294.52,
    x2: 313.06,
    y2: 307.47,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -7418.08,
    y1: 33.25,
    x2: -7400.35,
    y2: 33.25,
    gradientTransform: "translate(7719.53 80.49) rotate(-1.44)",
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -7641.96,
    y1: 1183.02,
    x2: -7654.14,
    y2: 1184.46,
    gradientTransform: "translate(7990.37 -87.93) rotate(6.11)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -7643.05,
    y1: 1188.48,
    x2: -7641.14,
    y2: 1175.92,
    gradientTransform: "translate(7990.37 -87.93) rotate(6.11)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -7638.28,
    y1: 1186.61,
    x2: -7643.82,
    y2: 1186.61,
    gradientTransform: "translate(7990.37 -87.93) rotate(6.11)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 383.31,
    y1: 267.99,
    x2: 401.22,
    y2: 267.99,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 393.32,
    y1: 283.93,
    x2: 390.56,
    y2: 229.3,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 39.82,
    y1: 320.58,
    x2: 72.59,
    y2: 320.58,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 15.06,
    y1: 320.84,
    x2: 34.28,
    y2: 320.84,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -32.21,
    y1: 331.89,
    x2: -21.99,
    y2: 331.89,
    gradientTransform: "translate(75.38 -10.27) rotate(.57) scale(1.1 1) skewX(-.75)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 98.77,
    y1: -893.53,
    x2: 108.98,
    y2: -893.53,
    gradientTransform: "translate(-73.78 920.75) rotate(.47) scale(.9 .67) skewX(-.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0073cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#157ed3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#56a1ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#70aff3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 782.24,
    y1: 310.95,
    x2: 864.92,
    y2: 310.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74818d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fa8b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 786.96,
    y1: 306.64,
    x2: 855.55,
    y2: 306.64,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 787.22,
    y1: 320.66,
    x2: 869.91,
    y2: 320.66,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 791.34,
    y1: 315.46,
    x2: 859.93,
    y2: 315.46,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 787.22,
    y1: 329.44,
    x2: 869.91,
    y2: 329.44,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 791.95,
    y1: 325.13,
    x2: 860.54,
    y2: 325.13,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 792.21,
    y1: 339.15,
    x2: 874.9,
    y2: 339.15,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 796.33,
    y1: 333.95,
    x2: 864.92,
    y2: 333.95,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 871.79,
    y1: 342.54,
    x2: 880.1,
    y2: 342.54,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 699.21,
    y1: 333.72,
    x2: 835.83,
    y2: 333.72,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 784.22,
    y1: 290.11,
    x2: 765.31,
    y2: 335.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#88939e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#c5cdd6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 709.97,
    y1: 310.09,
    x2: 758,
    y2: 310.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5cdd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5cdd6",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 690.5,
    y1: 322.2,
    x2: 765.38,
    y2: 383.64,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 754.55,
    y1: 286.26,
    x2: 754.73,
    y2: 291.34,
    xlinkHref: "#linear-gradient-67"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 699.72,
    y1: 286.75,
    x2: 732.56,
    y2: 240.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#274864",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#2c5271",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#3a6c95",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#4f95ce",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#559fdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 674.41,
    y1: 320.25,
    x2: 675.35,
    y2: 291.57,
    xlinkHref: "#linear-gradient-67"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 609.55,
    y1: 372.26,
    x2: 608.75,
    y2: 318.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5cdd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#c5cdd6",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#c5cdd6",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#c5cdd6",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#c5cdd6",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c5cdd6",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#c5cdd6",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#c5cdd6",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5cdd6",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 584.97,
    y1: 315.49,
    x2: 585.72,
    y2: 288.68,
    xlinkHref: "#linear-gradient-67"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 531.01,
    y1: 276.4,
    x2: 649.34,
    y2: 276.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#c5c7c8",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#708393",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3b5871",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#274864",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 517.43,
    y1: 291.21,
    x2: 531.53,
    y2: 294.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#c5c7c8",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#708393",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3b5871",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#274864",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 879.65,
    y1: 348.51,
    x2: 835.76,
    y2: 348.51,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 865.45,
    y1: 325.81,
    x2: 877.64,
    y2: 307.41,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: -773.76,
    y1: -867.17,
    x2: -760.05,
    y2: -867.17,
    gradientTransform: "translate(106.16 897.06) rotate(-179.62) scale(.92 -.67) skewX(.79)",
    xlinkHref: "#linear-gradient-55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 313.66,
    y1: 287.98,
    x2: 591.15,
    y2: 207.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#18344d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0073cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 312.23,
    y1: 236.9,
    x2: 570.8,
    y2: 236.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#c0bfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0073cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 24288.26,
    y1: 407.24,
    x2: 24435.09,
    y2: 407.24,
    gradientTransform: "translate(24877.04) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#bfc0c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6a7b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 24364.32,
    y1: 466.84,
    x2: 24364.32,
    y2: 450.45,
    gradientTransform: "translate(24877.04) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#707478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#82858a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#92949b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#9d9fa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#a4a5ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6a7b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 24383.56,
    y1: 458.97,
    x2: 24383.56,
    y2: 470.14,
    gradientTransform: "translate(24877.04) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#707478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8d8f96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6a7b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 295.11,
    y1: 407.24,
    x2: 441.94,
    y2: 407.24,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 371.17,
    y1: 466.84,
    x2: 371.17,
    y2: 450.45,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 390.41,
    y1: 458.97,
    x2: 390.41,
    y2: 470.14,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 24388.96,
    y1: 381.76,
    x2: 24392.31,
    y2: 372.08,
    gradientTransform: "translate(24877.04) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#e8e8ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfd0d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 395.81,
    y1: 381.76,
    x2: 399.16,
    y2: 372.08,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 425.09,
    y1: 361.08,
    x2: 442.68,
    y2: 310.27,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 24354.06,
    y1: 357.17,
    x2: 24358.77,
    y2: 343.57,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 24302.22,
    y1: 378.53,
    x2: 24255.63,
    y2: 327.56,
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 24280.8,
    y1: 385.6,
    x2: 24264.34,
    y2: 367.59,
    gradientTransform: "translate(24877.04) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4c9d3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#b5b8c2",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#aaabb5",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6a7b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 24334.63,
    y1: 348.67,
    x2: 24382.32,
    y2: 348.67,
    gradientTransform: "translate(24877.04) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 24336.91,
    y1: 349.11,
    x2: 24381.29,
    y2: 349.11,
    gradientTransform: "translate(24877.04) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 24305.04,
    y1: 426.42,
    x2: 24330.93,
    y2: 426.42,
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 24312.46,
    y1: 415.93,
    x2: 24332.84,
    y2: 415.93,
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 24341.2,
    y1: 504.92,
    x2: 24358.72,
    y2: 504.92,
    gradientTransform: "translate(24907.16 101.91) rotate(-179.52) scale(1 -1)",
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 196.59,
    y1: 6268.67,
    x2: 210.11,
    y2: 6268.67,
    gradientTransform: "translate(287.35 6661.96) rotate(.48) scale(1 -1)",
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 360.91,
    y1: 357.17,
    x2: 365.62,
    y2: 343.57,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 309.08,
    y1: 378.53,
    x2: 262.48,
    y2: 327.56,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 287.66,
    y1: 385.6,
    x2: 271.19,
    y2: 367.59,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-92"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 341.48,
    y1: 348.67,
    x2: 389.17,
    y2: 348.67,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-93"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 343.76,
    y1: 349.11,
    x2: 388.14,
    y2: 349.11,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-94"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 439.21,
    y1: 365.37,
    x2: 443.21,
    y2: 353.8,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 311.89,
    y1: 426.42,
    x2: 337.78,
    y2: 426.42,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 319.31,
    y1: 415.93,
    x2: 339.69,
    y2: 415.93,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 352.89,
    y1: 305.98,
    x2: 370.4,
    y2: 305.98,
    gradientTransform: "translate(-30.13 101.91) rotate(-.48)",
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 24184.9,
    y1: 6467.61,
    x2: 24198.43,
    y2: 6467.61,
    gradientTransform: "translate(24589.69 6661.96) rotate(179.52)",
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 296.13,
    y1: 304.01,
    x2: 587.75,
    y2: 304.01,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 441.94,
    y1: 349.87,
    x2: 441.94,
    y2: 364.45,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 441.88,
    y1: 352.69,
    x2: 441.88,
    y2: 361.4,
    gradientTransform: "translate(.08 .27)",
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 24268.42,
    y1: 327.58,
    x2: 24341.01,
    y2: 327.58,
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_27",
    x1: 24312.14,
    y1: 346.93,
    x2: 24322.14,
    y2: 346.93,
    gradientTransform: "translate(24877.04) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f25b0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#f57735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#f7935f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f99e6f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 24268.42,
    y1: 327.58,
    x2: 24341.01,
    y2: 327.58,
    gradientTransform: "translate(24877.04) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f4f5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#e1e1e3",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#d4d4d7",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfd0d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 275.27,
    y1: 327.58,
    x2: 347.86,
    y2: 327.58,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_27-2",
    x1: 318.99,
    y1: 346.93,
    x2: 328.99,
    y2: 346.93,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 275.27,
    y1: 327.58,
    x2: 347.86,
    y2: 327.58,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-113"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m772.58,251.81c0,139.07-147.68,50.37-329.86,50.37s-329.86,88.7-329.86-50.37S260.54,0,442.72,0s329.86,112.74,329.86,251.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m58.26,94.29c-.26-5.31,14.71-10.67,34.78,3.21,0,0,3.09-15.86,24.71-16.26,21.62-.4,33.59,16.26,33.59,16.26,0,0,10.04-26.97,32.04-24.99,22.01,1.98,22.39,24.99,22.39,24.99,0,0,24.71-3.57,34.36,12.29,9.65,15.86,3.09,24.59,3.09,24.59,0,0,13.9-5.95,23.55,2.38,9.65,8.33,0,14.67,0,14.67,0,0,11.97-3.17,22.39,9.92,10.42,13.09,8.11,10.71,14.67,9.52,6.56-1.19,31.66,9.52,30.89,13.48-.77,3.97-56.75-5.95-86.87-15.47-30.11-9.52-139.37-44.82-160.99-53.94-21.62-9.12-28.26-13.57-28.61-20.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m288.62,175.07c-6.95-7.27-26.38-9.39-26.38-9.39-4.89-16.53-20.08-12.16-20.08-12.16-2.57-14.39-13.26-11.5-13.26-11.5,2.19-13.35-6.95-13.88-6.95-13.88.9-3.83.77-11.37-7.21-17.98-7.98-6.61-22.78,0-22.78,0,0,0-7.85-6.35-19.43-2.09-11.58,4.25-15.44,17.69-15.44,17.69,0,0,.51-6.35-6.95-11.9-7.46-5.55-18.53-1.85-18.53-1.85,0,0,2.57-14.68-15.7-17.32-18.27-2.64-22.26,10.18-22.26,10.18-7.34-7.67-19.3-11.63-23.94-13.62-4.63-1.98-9.86,0-9.86,0,0,0-5.2,3.3,1.11,11.5,6.31,8.2,12.39,10.22,37.49,22.52,25.09,12.29,47.49,15.86,47.49,15.86,13.51,7.54,30.89,11.1,30.89,11.1,8.88,17.45,63.7,18.24,63.7,18.24,15.18,8.78,22.94,7.17,34.66,9.22s26.64,3.5,31.66,4.83c5.02,1.32,17.35,1.04,21.86,1.21,4.5.18,5.54-.89,5.54-.89-2.14.12-38.66-2.5-45.61-9.77Zm-76.62-31.25s-5.66-9.7-10.3-11.28c-4.63-1.59-9.82-.71-17.52,2.47,0,0,5.68-9.7,17.52-7.58,11.84,2.12,10.3,16.39,10.3,16.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m205.02,54.93s-10.47-3.53-8.75-8.46c1.72-4.94,14.59-.71,16.3,3.17,0,0,3.6-13.11,15.62-5.41,0,0,2.06-3.58,19.39.47,17.33,4.05,17.85,16.92,17.85,16.92,0,0,12.35-3.35,15.44,8.11,0,0,17.5,2.64,16.13,9.17-1.37,6.52-91.98-23.97-91.98-23.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "m196.27,46.47s5.7-2.82,12.12,2.12c6.42,4.94,6.07,6.7,6.07,6.7,0,0,4.29-6.09,13.38-4.81,9.09,1.28,18.36,5.16,19.91,13.45,0,0,6.18-4.58,11.67-.88,5.49,3.7,5.15,7.05,5.15,7.05,0,0,9.27-.71,13.73,3.17,4.46,3.88,17.16,5.99,18.7,5.64,0,0-1.89,4.19-14.31.91,0,0-8.69,3.99-19.5,1.25-10.81-2.74-17.22-7.62-22.82-8.88-5.6-1.26-14.03-1.42-20.08-3.86-6.05-2.45-13.86-5.53-15.66-10.36,0,0-10.68-6.41-8.37-11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "m82.5,159.29c19.12,8.29,72.23,21.68,82.66,20.88,10.42-.79-22.39-10.31-28.96-11.9,0,0,1.54-14.67-31.66-16.26,0,0,2.94-7.46-11.2-14.17-12.73-6.05-13.9,7.04-13.9,7.04,0,0-23.16-23-32.04-10.31,0,0-13.9-16.26-20.08-15.07-6.18,1.19,5.76,18.38,55.17,39.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m723.59,130.06s34.75-6.08,35.26-17.72c.51-11.63-23.94-1.59-23.94-1.59,0,0-2.06-5.22-9.78-4.99-7.72.23-10.81,5.26-10.81,5.26,0,0-9.34-7.67-30.67-2.12-21.33,5.55-22.61,22.74-22.61,22.74,0,0-8.75-7.14-21.62-3.97s-18.27,15.6-17.25,23c0,0-9.52-.79-17.5,5.02-7.98,5.82-12.61,3.7-23.42,5.82-10.81,2.12-14.67,6.35-24.45,6.87-9.78.53-1.03,5.55,27.03,2.12,13.6-1.67,49.26-6.55,79.92-15.96,32.59-10,59.84-24.5,59.84-24.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "m756.99,107.98s-16.23-.04-24.68,8.11c0,0-6.39-1.63-10.51,2.07-4.12,3.7-7.21,7.93-7.21,7.93,0,0,2.06-9.25-10.55-7.67-12.61,1.59-9.01,12.16-9.01,12.16,0,0-4.97-4.5-11.36-2.12-6.4,2.38-8.91,8.93-8.46,12.96,0,0-13.13-11.11-25.22,3.7,0,0,13.51-3.17,19.05,5.82,0,0-14.67-7.93-24.45,2.51,0,0-9.39-3.57-14.41,4.76,0,0-9.01-1.32-13.26,1.72-4.25,3.04-16.47,4.23-22.39,6.35-5.92,2.12-30.66,4.76-33.99,5.22,0,0,18.03,3.77,37.85-.99,19.82-4.76,17.5,1.19,40.02-3.57,22.52-4.76,38.74-12.56,42.34-16,0,0,16.6,1.32,36.94-5.02,20.33-6.35,17.63-14.01,6.82-14.94,0,0,24.45-5.02,30.24-10.18,4.95-4.41,6.3-10.18,2.25-12.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m486.29,76.04s18.79,5.77,40.41,1.54c21.62-4.23-1.54-7.14-1.54-7.14,0,0,1.29-4.43-5.15-4.73s-19.05,4.46-19.05,4.46c0,0-3.09-2.91-6.43-2.25-3.35.66-2.57,2.78-2.57,2.78,0,0-12.87-1.87-15.44,1.71-2.57,3.58,9.78,3.62,9.78,3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m554.05,104.11s3.6-6.35,11.84-7.14c8.24-.79,14.41,3.57,14.41,3.57,0,0,.51-13.36,20.85-18.51,20.33-5.15,15.19,9.12,15.19,9.12,0,0,8.75-8.95,21.36-11.35,12.61-2.4,16.22,5.27,16.22,5.27,0,0,16.49-9.13,19.06.79,2.57,9.92-75.43,24.86-75.43,24.86,0,0-60.27,14.26-70.27,0-4.63-6.61,26.77-6.61,26.77-6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "m530.24,113.41s16.35,3.03,24.32-.62c7.98-3.65,13.64-8.41,21.88-2.86,0,0,2.57-7.14,8.75-8.73,6.18-1.59,13.13.26,15.96,5.55,0,0,.32-6.74-7.66-9.25,0,0,5.41-4.76,13.32-3.97,7.91.79,8.3,4.64,8.3,4.64,0,0,6.24-4.17,13.51-2.98,7.27,1.19,7.46,5.22,7.46,5.22,0,0,3.41-9.25,11.65-9.25,6.05,0,7.72,2.29,7.72,2.29,0,0,2.04-8.59,11.58-9.43,9.54-.84,6.46,7.96-1.67,9.65,0,0,2.19,7.67-19.05,14.28-21.23,6.61-25.1,9.25-37.97,11.24-12.87,1.98-24.71-2.12-24.71-2.12,0,0-18.79,3.34-28.06,2.66-9.27-.67-22.14-1.57-25.35-6.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "m752.77,58.4s11.02-5.24,13.19-.51c2.17,4.73-33.12,28.53-49.71,27.13-16.59-1.4,8.59-9.12,8.59-9.12,0,0,3.5-8.28,9.12-9.69,0,0,9.05-14.56,18.81-7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m356.52,148.19s28.55,1.91,37.84,8.03c0,0,24.93,4.61,25.52,7.36.59,2.75-51.13-1.21-80.67-11.31-29.53-10.1-41.79-9.42-64.47-23.32-22.68-13.9-16.3-14.77,1.98-5.53,0,0,22.38-.17,31.44,12.82,0,0,3.29-9.08,21.7-5.24,18.41,3.84,14.98,11.22,14.98,11.22,0,0,12.78-2.07,11.67,5.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "m500.27,191.55c-3.95-2.14,8.58-3,13.73-3.17,5.15-.18,5.3,1.06,14.32-2.29,9.02-3.35,15.19,2.73,15.19,2.73,0,0,7.72-2.15,10.47-.5,2.75,1.65-14.6,5.35-25.66,5.7-11.06.35-23.41.04-28.05-2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "m425.98,135.84s-15.86-4.47-16.69-1.92c-.82,2.55,8.93,6.8,16.66,6.49,7.72-.31,9.69.69,18.73,3.02,7.04,1.81,23.8,2.55,26.82-.54s-19.05-3.49-19.05-3.49c0,0-10.03-17.36-26.46-3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "m342.21,200.89c.55,2.11,46.07,9.78,50.96,9.52,4.89-.26,40.67,1.06,52.51,2.38,11.84,1.32,27.28.79,28.06-1.32.77-2.12-18.02-5.93-26.77-5.67-8.75.26-22.91-9.4-34.75-1.47-11.84,7.93-21.36-7.93-37.58-5.29,0,0-11.84-1.92-20.08-.3-8.24,1.62-13.38-1.81-12.35,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m530.24,221.81s-56.72-1.59-56.47,3.57c.25,5.16,58.1,4.85,70.13,5.16,18.15.46,40.15-5.16,50.96-4.76,10.81.4,25.48-.79,59.84-9.12,19.46-4.72,63.32-16.26,64.86-21.02,1.54-4.76-37.06,3.57-40.15,7.14,0,0-21.23-2.29-31.27,3.02,0,0-11.97-5.31-19.3,0,0,0-15.44-7.38-20.46,4.91,0,0-12.35-3.92-16.6,2.8,0,0-8.49-16.68-24.32-5.97,0,0-16.79-5.09-17.66,6.77,0,0-19.67-4.86-19.54,7.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m525.99,257.51c2.5,4.11,70.41,13.88,96.28,13.48,25.87-.4,49.8,1.98,52.51-2.78,2.7-4.76-11.2-3.57-13.13-6.35-1.93-2.78,51.35,1.98,70.26-4.36,18.92-6.35,30.89-11.9,44.01-13.09,13.13-1.19,58.68-15.47,74.9-26.57,16.21-11.1,13.9-10.13-1.54-5.46-15.44,4.67-51.73,21.53-84.55,27.78-32.82,6.24-62.93,3.07-97.29,6.64-34.36,3.57-62.16,9.52-97.61,8.73-22.51-.5-47.46-3.97-43.84,1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m186.49,196.92c.76-8.11,63.83-7.14,63.83,6.87,12.1,3.97,5.41,11.9,5.41,11.9,0,0,28.83-8.99,51.48,1.85,0,0,39.64-9.52,45.82,12.16,0,0,29.6-1.85,41.7,4.5,12.1,6.35,36.29,3.97,38.61,8.46,2.32,4.5-61-1.06-75.93,0-14.93,1.06-76.45,3.7-80.82-5.02,0,0-53.12-4.16-68.65-5.02-19.12-1.06-38.42-9.52-38.42-9.52,0,0-28.57-1.59-35.26-8.73,0,0-28.31-7.14-28.06-16.92.26-9.78,54.82,4.5,57.4,6.61,0,0,17.5.79,23.68,2.64,6.18,1.85,11.84,3.44,18.53,7.93,5.41-2.64,7.72-3.7,15.96-4.5-5.66-2.12-36.04-5.02-35.26-13.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m59.34,218.13c-1.98-4.12,19.35.9,36.03,5.77,8.03,2.35,16.3,3.73,24.64,4.1,8.82.4,20.27,1.15,27.87,2.56,13.9,2.58,41.7,9.73,45.3,9.6s51.22,7.53,62.29,8.59c11.07,1.06.26,3.7-6.95,3.17-7.21-.53-38.5-4.23-38.5-4.23,0,0-20.44,1.59-30.22-2.12,0,0-4.52,4.23-20.02.79-15.5-3.44-23.99-7.14-23.99-7.14,0,0-14.41,0-20.33-2.91,0,0-24.19-1.59-35.26-11.11,0,0-18.79-2.81-20.85-7.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m917.48,150.28c1.98-1.74-21.17,1.91-29.98,8.58-8.8,6.67-21.48,13.96-25.43,12.03-3.95-1.93-13.99-4.34-18.59,1.28,0,0-.07-13.25-15.7-12.42s-15.91,10.25-15.91,10.25c0,0-17.92,4.21-12.03,20.45,0,0-10.94,3.69-8.33,12.23,0,0-10.69-5.54-16.1,4.31,0,0-6.68-7.75-16.38-2.54-9.69,5.21-12.11,14.1-12.11,14.1,0,0-22.34-.16-28.57,8.99-6.22,9.15,58.81-12.52,58.81-12.52,0,0,24.67-8.18,49.12-20.45,24.45-12.28,80.72-35.02,91.19-44.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "m827.28,182.11s.99-10.42-9.65-9.43c-10.64.99-8.23,15.93-5.63,18.89,0,0-6.99,2.96-6.27,6.86,0,0-9.38-.59-9.09,8.05,0,0-7.92-.57-13.08,3.17-5.15,3.74-14.79,7.91-21.12,8.44-6.34.53-39.66,13.42-43.27,8.36,0,0-1.53,1.15-1.18,2.47.35,1.32,6.71,1.87,15.11-.33,8.39-2.19,13.8.22,34.06-7.35,20.26-7.57,33.36-10.7,43.09-15.12,9.73-4.41,20.14-7.59,35.43-15.99,15.29-8.4,28.22-12.51,45.44-21.94,17.22-9.43,27.41-16.52,26.56-18.03-.85-1.52-13.3,8.53-17.54,9.2-4.24.67-18.23,7.11-23.72,10.9-5.49,3.79-14.85,5.83-14.85,5.83,0,0-9.13-6.15-17.12,2.54,0,0-.65-3.7-5.72-3.63-5.07.06-11.46,7.1-11.46,7.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "m226.23,388.1c-42.4,0-191.86,17.92-199.52,20.67-23.84,8.55,49.22,11.3,141.16,11.3,40.31,0,130.04-15.52,183.63-25.16,53.58-9.63-115.61-6.81-125.27-6.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "m634.15,482.49c-106.65,21.24-302.32,21.66-384.32,0-9.26-4.88,2.48-15.28,23.83-30.3h0c17.03-11.97,34.21-20.03,41.25-20.03h254.15c7.04,0,24.22,8.06,41.25,20.03h0c21.36,15.01,35.01,27.53,23.83,30.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m262.57,250.41c17.55-1.35,83.81-2.83,110.24-.55s-36.05-12.28-64.88-11.66c-28.83.62-45.36,12.21-45.36,12.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m370.36,251.66c-19.62-.25-50.77-5.25-52.27-5.41s5.34,38.64,4.29,43.8c-1.05,5.16-7.3,7.25-7.3,7.25,0,0-3.23-43.47-6.03-48.42-2.8-4.96-5.47-8.44-5.47-8.44,0,0,56.11,5.64,63.22,7.79s3.57,3.42,3.57,3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m129.3,284.85v-5.25s42.33-21.92,49.88-24.15c7.56-2.23,14.95-2.35,14.95-2.35h16.26s-13.19,20.01-18.05,34.53c31.55-5.55,27.47-9.48,27.47-9.48,0,0-4.23,2.29-5.83-1.9-1.6-4.19,3.11-10.88,3.11-10.88l6.19-11.64,28.89.99,20.65-13.5s-48.88-4.9-67.41-2.17c-18.53,2.73-41.62,9.97-47.74,13.12-6.13,3.15-41.42,22.75-47.08,26.95-5.66,4.2-11.08,9.86-11.08,9.86l29.8-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m137.26,284.24c8.82-2.76,25.51-4.21,32.07-5.07s13.08,0,13.08,0l-1.04,7.7-44.11-2.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m422.32,373.16c0,12.35-5.03,24.59-16.65,29.83-4.5,2.03-11.55,1.65-16.83,1.65-13.47,0-26.14-14.38-26.61-33.51-.47-18.97,10.58-33.88,24.26-33.45,13.23.42,35.2,17.6,35.83,35.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m100.41,371.37c0,14.59-5.94,29.05-19.67,35.23-5.31,2.39-13.64,1.95-19.88,1.95-15.91,0-30.87-16.99-31.43-39.58-.55-22.41,12.5-40.02,28.65-39.51,15.63.49,41.58,20.79,42.32,41.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m100.38,367.28c.74,21.27-11.09,39.26-26.91,40.05-16.35.82-30.46-16.95-31.02-39.54-.55-22.41,12.5-40.02,28.65-39.51,15.63.49,28.54,17.88,29.27,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m93.9,369.56c.52,14.94-7.79,27.58-18.9,28.13-11.48.57-21.4-11.91-21.79-27.77-.39-15.74,8.78-28.11,20.13-27.75,10.98.35,20.04,12.56,20.56,27.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m297.56,370.11c0,11.42-4.65,22.74-15.4,27.58-4.16,1.87-10.68,1.53-15.56,1.53-12.46,0-24.17-13.3-24.61-30.99-.43-17.55,9.79-31.33,22.43-30.93,12.24.39,32.56,16.27,33.13,32.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m297.53,366.91c.58,16.66-8.69,30.74-21.07,31.36-12.8.64-23.85-13.27-24.29-30.96-.43-17.55,9.79-31.33,22.43-30.93,12.24.39,22.34,14,22.92,30.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m292.46,368.7c.41,11.7-6.1,21.59-14.8,22.02-8.99.45-16.75-9.32-17.06-21.74-.3-12.32,6.87-22.01,15.76-21.73,8.6.27,15.69,9.83,16.1,21.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m228.69,372.42c0,16.5-6.72,32.85-22.24,39.85-6.01,2.71-15.42,2.21-22.48,2.21-17.99,0-34.92-19.21-35.55-44.76-.62-25.34,14.14-45.26,32.41-44.68,17.68.56,47.03,23.51,47.86,47.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "m263.29,242.81c-10.5-.46-41.1-1.45-67,1.3-25.75,2.74-30.29,5.04-39.72,9.74s-36.65,20.4-43.85,25.12c-7.2,4.72-7.52,6.95-7.52,6.95,0,0,24.5-2.53,45.89-2.38,21.39.15,43.43-.7,47.92-.91,4.49-.22,6.95-.97,6.95-.97l19.5-4.25,4.35-.95,37.23-33.47s-1.35-.08-3.76-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "m263.29,242.81c-10.5-.46-41.1-1.45-67,1.3-25.75,2.74-30.29,5.04-39.72,9.74s-36.65,20.4-43.85,25.12c-7.2,4.72-7.52,6.95-7.52,6.95,0,0,24.5-2.53,45.89-2.38,21.39.15,43.43-.7,47.92-.91,4.49-.22,6.95-.97,6.95-.97l19.5-4.25,4.35-.95,37.23-33.47s-1.35-.08-3.76-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m199.01,282.64c-4.49.22-26.53,1.07-47.92.91-21.39-.15-45.89,2.38-45.89,2.38,0,0,.32-2.23,7.52-6.95,7.2-4.72,34.41-20.41,43.85-25.12s13.98-7,39.72-9.74c25.9-2.76,56.5-1.77,67-1.3l2.18-.04,17.39-5.87s-39.78.3-57.61.84-28.94,2.11-43.64,5.33c-14.7,3.22-24.51,8.24-42.92,18.18-18.41,9.94-28.62,17.73-34.13,20.41-5.51,2.68-15.19,5.67-22.96,6.23l134.34,2.16,9.53-12.63-19.5,4.25s-2.46.75-6.95.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m18.06,306.95s-3.38.51-5.53,1.31c-2.15.8-4.4,5.17-4.33,8.8s2.63,10.62,2.63,10.62l7.23-20.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m11.36,341.38c-2.72-5.24-1.76-19.49-1.35-22.68s.87-9.35,19.06-18.14c18.19-8.79,47.85-12.87,61.54-13.27,13.7-.4,43.53-1.77,43.53-1.77,0,0,52.04-.96,54.92-1.04s26.87.37,26.87.37L11.36,341.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m78.43,320.81c-4.88,2.84-15.73,13.08-32.7,12.67-16.98-.41-27.46-12.04-27.46-12.04l-4.16.77s-1.52,7.61-1.36,12.81-5.45,14.65,4.87,16.63,61.55-.37,68.71-1.67c7.16-1.3,15.69-19.37,16.02-19.93s-1.46-13.08-2.23-13.28-15.54-.42-17.77.52c-2.23.94-3.9,3.52-3.9,3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m106.53,286.86c-14.19,0-45.48,5.45-65.61,10.82-8.54,2.28-12.89,4.59-16.63,6.38-7.14,3.4-13.07,8.23-13.46,15.97-.39,7.73,59.46-3.51,59.46-3.51l8.89,9.34,46.78-8.18,59.24-15.78s22.74-19.1,21.95-19.01c-18.03,3.22-100.62,3.97-100.62,3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "m106.68,287.94c-13.32,0-42.66,5.11-61.55,10.15-8.01,2.13-12.09,4.31-15.6,5.99-6.7,3.19-12.27,7.73-12.63,14.98-.36,7.25,55.78-3.29,55.78-3.29l8.34,8.76,43.89-7.67,55.57-14.8s21.33-17.92,20.6-17.83c-16.92,3.02-94.4,3.72-94.4,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m10.01,323.3s.7-2.88,1.17-4.6c.47-1.71,1.35-4.01,5.34-4.49,3.99-.49,27.05-1,39.28-1.16,12.23-.16,14.61.28,15.96.24,1.35-.04,4.6,3.15,4.19,5.08s-.77,2.85-.77,2.85l-4.53,5.38c-.49.9-5.05,5.78-5.05,5.78l.46-8.23-56.02-.44-.02-.41Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "0 340.38 .58 345.29 11.82 350.37 12.53 346.51 10.42 341.29 2.66 339.2 0 340.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "m10.01,323.3c.17,2.69-.09,7.83.44,10.45s1.13,5.58,2.7,6.72c1.57,1.13,1.91,2.22,1.91,2.22,0,0-2.44.58-2.53,1.49s0,2.33,0,2.33c0,0-2.88-1.84-3.49-3.16s-.79-2.71-4.54-2.71S0,340.38,0,340.38c0,0,1.08-7.07,1.62-9.6s8.39-7.49,8.39-7.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m70.64,326.6c4.3-7.16,20.29-9.45,20.29-9.45,0,0,38.06-12.09,36.28-11.83-33.87,4.2-51.74,9.06-56.57,21.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "m89.97,323.17s-6.86,3.98-14.02,8.95c4.87-1.19,31.43-4.97,31.43-4.97l10.71-7.56-28.11,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "m80.82,342.69l7.45-12.9s17.26-7.5,24.11-8.49,51.81-8.01,51.81-8.01l-2.51,14.7-80.86,14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m81.6,341.62l4.57-7.1c1.27-1.96,3.44-3.14,5.78-3.15,7.04,0,22.75-.35,35.9-3.09,17.53-3.65,24.93-2.72,24.93-2.72l-7.49,29.5-52.83,8.73-10.87-22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m112.08,322.53c-1.03-.21-6.2.28-11.62.56,0,0-6.19.16-6.82.16-5.8,0-9.11-4.93-9.11-4.93l1.89-2.02c9.5-7.14,41.39-11.25,50.37-12.16,10.46-1.06,18.88-2.2,24.38-2.25h.34s.32.1.32.1c.83.26,3.37,1.05,3.42,3.3.03,1.34-.94,2.53-2.61,3.2l-13.98,9.96s-12.99,3.61-14.52,4.07c-2.35.71-8.25,1.18-12.6,1.18-3.07,0-7.42-.75-9.46-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "m161.2,304.05c-10.12.09-35.8,2.24-51.02,5.23-15.22,2.99-22.08,6.41-24.24,9.18.86,2.59,6.4,3.15,10.66,3.15,8.66,0,12.37-.65,14.44-.5,2.08.15,5.63,1.39,9.95,1.42,4.32.03,10.12-.79,12.19-1.42,2.08-.63,7.18-1.09,7.18-1.09l21.32-13.46s3.51-1.26-.48-2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "m88.92,318.46c.46,1.19,5.92,2.12,10.45,1.56,4.53-.56,12.18-.55,12.18-.55,0,0,16.15.7,18.53.85s8.36-.93,8.36-.93c0,0-.98,1.14-1.64,1.33-3.64.8-10.94,2.24-17.21,1.82-6.27-.42-6.55-1.55-10.44-1.35-3.88.19-10.58.77-16.98.2-6.4-.57-6.23-2.92-6.23-2.92l.72-.25s.57.2,2.26.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m134.14,309.28s-12.17,2.72-16.05,3.16-5.37,1.42-5.37,1.42c0,0,.28,4.35-1.17,5.6,6.24.5,8.1,3.26,12.84,1.65,4.74-1.61,4.78.43,6.8-1.65,2.02-2.08,3.03-6.67,2.95-10.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "m163.02,305.08s-8.27.38-16.73,2.24c-4.12.91-9.5,13.4-9.5,13.4,0,0,5.5-.72,9.19-2.18s15.66-11.24,15.66-11.24l1.37-2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m163.51,305.18s-9.79,1.86-13.91,2.77-9.25,12.07-9.25,12.07c0,0,5.5-.72,9.19-2.18s15.66-11.24,15.66-11.24l-1.69-1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m164.04,305.18s-9.79,1.86-13.91,2.77-9.25,12.07-9.25,12.07c0,0,5.5-.72,9.19-2.18s15.66-11.24,15.66-11.24l-1.69-1.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-174",
    cx: 127.21,
    cy: 315.45,
    rx: 3.98,
    ry: 4.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "m88.92,318.46c1.16-1.52,12.57-6.27,34.31-9.52,21.74-3.26,36.59-3.76,36.59-3.76,0,0-16.6-1.02-42.04,3.49-25.44,4.51-29.63,7.88-31.12,9.54.99.94,2.26.25,2.26.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m1.62,369.09S.03,375.37,0,376.68c-.03,1.31,7.93,0,7.93,0,0,0,68.79,2.05,72.89,2.6s15,.9,21.57.03-14.56-13.39-14.56-13.39l-86.21,3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m62.72,347.31s-48.12-.13-49.95,0-3.05-.09-3.83-.8c-.78-.72-3.05-3.37-3.05-3.37,0,0-4.79-.21-5.23,0-1.74.65.43,24.25.95,25.95,3.66.39,12.98-.74,12.98-.74l70.9.99-22.77-22.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m8.65,363.52c.26,1.07.34,1.63.34,1.63,0,0,62.22,2.28,66.29,2.15,4.07-.12.78-3.99.78-3.99l-67.41.21Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-66",
    points: "66.94 357.84 66.18 357.83 8.65 356.76 8.65 363.86 71.24 364.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m62.72,347.31s2.93,13.45,9.77,20.95c1.51,1.84,20.46,2.13,20.46,2.13l-18.82-27.25-11.41,4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m62.72,347.31l5.62,12.2,15.4,1.37.66-16.7s-12.95-1.87-15.33,0c-2.38,1.87-6.35,3.13-6.35,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m83.61,344.18s-2.44,6.12-2.79,15.74c.35,2.25,3.81,8.88,8.84,12.5,5.03,3.62,10.32,6.83,10.32,6.83l64.82,1.86-.62-19.11-64.82-2.07-12.66-12.61-3.11-3.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "115.1 373.87 109.01 373.87 83.63 345.25 69.17 345.25 62.72 347.31 69.48 342.27 84.05 342.27 99.37 358.98 114.11 358.46 129.3 369.7 127.85 374.46 115.1 373.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "m132.68,346.51s-18.31,2.28-23.72,3.89c-5.41,1.61-9.59,8.59-9.59,8.59h6.98l17.93-6.14,12.52-1.1-4.12-5.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "131.77 349.9 112.28 353.23 106.35 358.98 109.62 360.37 116.08 369.94 135.63 369.94 131.77 349.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m131.59,351.74s-7.12-.1-13.19,3.65-4.07,10.64,2.7,13.01c6.76,2.37,16.17-.48,16.17-.48l-5.67-16.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "m413.76,282.3c5.05,5.13,18.27,24.98,18.27,24.98,0,0,5.61,7.83,6.95,21.17,1.35,13.38-2.46,38.01-9.5,34.62-7.15-3.43-38.08-9.93-48.34-3.33-10.52,6.76-99.9,9.83-107.68,9.45-7.9-.39-37.88,15.06-41.98-22.51-4.07-37.32-1.91-53.89-1.91-53.89l184.19-10.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "m235.29,354.45l29.02-1.72s79.02-5.7,83.99-7.4c4.91-1.68,25.81-3.77,25.81-3.77,0,0,1.86,28.83-6.96,29.42-8.99.6-107.81-.91-107.81-.91l-24.35.27.3-15.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m238.79,365.48s79.1-3.18,91.86-4.33c12.43-1.11,37.98-3.46,37.98-3.46,0,0,4.44-1.51-.39,2.92s-105.35,12.97-116.47,11.99c-11.37-.99-12.49-1.28-12.49-1.28l-.48-5.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "m237.2,354.45s71.65-2.22,92.88-4.34c20.31-2.02,39.87-8.61,39.87-8.61,0,0-36.08-1.1-64.67,1.17-30.38,2.41-68.07,11.78-68.07,11.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "m232.27,286.62l94.4-3.21,26.18-.36,17.59-.68s28.48-3.81,32.6-3.35c4.09.46,14.69,2.04,21.07,3.49,6.29,1.43,6.65,9.31,6.65,9.31,0,0,3.56-.2-18.46-.82-30.98-4.7-43.66,4.44-43.66,4.44,0,0-63.48,17.11-101.58,22.42-10.87-.83-27.88-16.08-40.25-19.9-6.66-2.06,5.47-11.33,5.47-11.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m236.8,295.77c17.32,2.76,22.69,12.02,44.43,8.28,21.74-3.73,97.51-14.69,97.51-14.69l-141.94,6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "m236.8,295.75c15.81-2.1,18.82-3.54,40.85-4.64,34.94-1.75,101.09-1.77,101.09-1.77l-141.94,6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "m425.91,284.04s-27.18-3.06-53.1-1.47c16.71-3.63,17.55,1.45,11.84-15.71,7.12-3.09,14.18-5.29,17.56-5,10.12.89,23.69,22.17,23.69,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m268.89,240.45l.28-1.03c6.73-9.19,23.54-10.39,31.52-10.32,7.86.07,30.49,1.15,47.12,3.39,16.14,2.18,34.82,5.97,47.2,16.19,2.04,1.8,2.36,2.49,2.36,2.49l-5.58.6s-11.42-7.47-14.9-9.62c-3.5-2.16-26.91-6.3-26.91-6.3,0,0-32.54-2.81-41.31-3.44-8.91-.64-23.8,3.47-23.8,3.47-1.2.5-2.01,1.02-2.01,1.02,0,0-8.89,3.75-10.65,3.26s-3.33.29-3.33.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "m301.66,235.31c24.22,1.85,67.85,3.79,82.51,10.6,6.53,6.61-5.22,6.01-5.22,6.01,0,0-24.03-8.78-50.36-12.02-27.85-3.42-26.93-4.6-26.93-4.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "351.62 236.07 349.97 235.86 350.28 241.44 353.78 242.16 351.62 236.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "380.76 242.24 379.03 241.51 381.28 250.98 383.6 249.51 380.76 242.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m359.67,237.33s-5.03-1.09-8.05-1.26c.45,1.15,1.32,5.42,1.32,5.42l8.11,1.28-1.38-5.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m380.76,242.24l2.46,8.01s10.99,1.17,10.35.59c-4.35-4.58-9.76-7.74-12.81-8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "m230.46,274.04s17.99-14.12,32.11-23.63c13.68-9.22,26.01-11.51,26.02-11.51l4.39-3.38s-8-1.61-22.03,3.9-40.66,32.28-49.54,37.05c-9.05,4.86,9.06-2.43,9.06-2.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "380.22 261.36 380.22 261.36 378.86 256.34 380.22 261.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "m399.23,252.16s-.92-.94-1.87-.98c-.95-.04-3.9-.62-15.51-3.92-11.9-3.38-42.1-8.94-53.42-10.37-30.28-3.81-39.97-1.95-46.89-.67-7.09,1.32-10.08,1.6-21.3,9.4-14.12,9.51-24.42,19.7-24.42,19.7,0,0-12.01,10.07-15.23,11.13-3.24,1.06-5.5,3.55-6.96,4.03-1.46.48-12.95,5.44-47.65,14.46,8.51,16.42,59.4-.03,59.4-.03,0,0,2.69-3.25,6.23-6.78l-1.74.09c-1.06.05-1.67-1.84-.87-2.72.67-.74,1.51-1.67,2.56-2.83,7.64-8.46,17.19-14.55,23.04-18.47,5.77-3.87,29.08-20.73,43.97-22.41,14.43-1.63,33.34.1,48.48,3.36,14.68,3.16,26.56,7.16,36.27,11.89,3.61,1.76,5.44,4.52,6.32,7.28,6.7,2.19,11.31,3.85,11.31,3.85l9.12-5.03-10.83-10.98Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "331.89 256.47 332.33 245.75 331.89 256.47 331.89 256.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "m252.58,264.85c-13.22,8.82-20.51,14.89-22.8,16.03-2.3,1.15-13.03,5.38-14.13,6.41-1.1,1.03,15.32,1.8,15.32,1.8l12.23-16.54,9.38-7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "m253.24,264.67c-11.76,8.68-18.21,14.56-20.25,15.71-2.05,1.16-11.62,5.5-12.58,6.49-.96.99,13.86.95,13.86.95l7.01-11.57,11.95-11.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m214.72,280.49l-10.6,3.42s-7.7,2.11-11.79,3.72-13.86,3.88-18.52,5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "m229.15,287.92c-9.83-.32-43.37,2.09-54.63,4.67-11.51,2.64-37.72,11.56-37.72,11.56,0,0,18.59-1.21,22.56-1.49,2.53,1.42,75.87,10.81,75.87,2.83,0-7.95.14-18.67.48-19.56-1.47.03-6.56,1.99-6.56,1.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "139.44 337.66 168.08 311.68 190.6 382.94 165.83 373.95 135.63 370.39 139.44 337.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "m164.99,305.11c.38-1.2-5.63-2.45-5.63-2.45,0,0,11-7.9,34.37-8.91,22.39-.97,35.45,3.31,41.62,9.94-1,9.07,3.51,38.51,3.51,38.51,0,0,1.2,13.73,5.52,20.63,1.15,2.05,1.39,2.46,1.39,2.46l-10.9.07-68.36-23.5s2.23-10.7-2.13-14.09c-4.39-3.41-16.09-9.32-16.09-9.32,0,0,16.31-12.14,16.69-13.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m235.35,303.7c-1,9.07,3.51,38.51,3.51,38.51,0,0,1.2,13.73,5.52,20.63,1.15,2.05,1.39,2.46,1.39,2.46l-10.9.07-68.36-23.5s2.23-10.7-2.13-14.09c-4.39-3.41,64.78-30.71,70.96-24.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "m323.99,244.92s-14.38-3.05-30.42.6c-15.71,3.57-35.92,19.1-42.96,23.91-4.52,3.08-6.46,4.78-7.27,5.59-.35.35-.56.89-.61,1.51l-.63,8.61,77.24-2.18,4.64-38.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "m332.33,245.75l-1.52,36.91s23.39-.05,32.21-.72c8.64-.66,22.19-2.11,22.19-2.11l-6.34-23.49s-20.03-7.54-46.54-10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m323.99,244.92s-14.38-3.05-30.42.6c-15.71,3.57-35.92,19.1-42.96,23.91-4.52,3.08-6.46,4.78-7.27,5.59-.35.35-.56.89-.61,1.51l-.63,8.61,77.24-2.18,4.64-38.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "m332.33,245.75l-1.52,36.91s23.39-.05,32.21-.72c8.64-.66,22.19-2.11,22.19-2.11l-6.34-23.49s-20.03-7.54-46.54-10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m428.49,282.07s1.77,2.7,3.27,4.06c1.5,1.36,2.31,2.31,2.6,4.74.29,2.43-5.83.06-5.83.06,0,0-1.7-4.02-2.09-4.99s-2.33-3.43-2.33-3.43l-.04-3.35,4.43,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "m433.55,302.98s.41,7.18.54,7.98c.14.8-7.17-3.28-8.77-5.53-1.6-2.25-2.48-3.66-2.48-3.66l10.71,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m434.36,290.88s-4.05-.95-9.67-1.67c-5.69-.73-10.61.26-11.63.73-1.02.47-1.05,1.7.21,3.28,1.26,1.58,9.62,9.21,10.45,9.96.84.75,1.46.75,1.46.75,0,0,5.77-.82,7.9-.77,2.11.05,2.87-10.26,1.27-12.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m404.06,253.77c3.96,1.4,9.94,1.12,11.35,2.05,1.41.94-.54,2.11-.54,2.11l-2.59,1.64s.86,2.07,2.23,3.67c1.37,1.59,10.12,12.72,12.68,16.6,2.54,3.87,3.11,5.19,3.11,5.19,0,0-2.44-1.9-3.63-2.11s-2.57-.43-2.57-.43c0,0-3.12-4.3-6.59-7.78-3.5-3.5-12.01-12.09-12.01-12.09l-.29-5.51-1.15-3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m389.08,280.17s2.92,9.55,3.39,11.51c.47,1.96-1.28,15.15-2.77,18.76-2.49,6.05-5.76,9.17-6.59,10.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "m420,300.83l14.22,14.77s1.3,8.92,1.61,14.74c.31,5.82-.36,13.28-.66,15.99-.3,2.72-1.14,4.72-1.14,4.72l7.67-16.86-3.2-18.45-4.39-5.47-4.72-2.07s-12.1-10.52-16.13-14.99c1.56,2.15,6.72,7.61,6.72,7.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "m141.94,336.11l.82.5s-1.58,22.98-1.55,24.71c.04,1.73,1.88,7.3,2.78,8.54.9,1.24,13.27.63,13.27.63,0,0-9.32,4.19-17.09,2.04-7.87-2.18-.73-34.87-.73-34.87l2.49-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m159.34,372.75l1.16,7.53s-19.48.34-28.07-.44c-8.71-.8-19.74-.46-19.74-.46,0,0-4.67-2.05-3.68-5.51,0,0,11.23-1.17,14.84-3.11,3.58-1.93,6.86-10.28,6.86-10.28l2.07-20.56,7.58-2.25s-1.73,20.17-1.89,22.8c-.16,2.63,1.33,5.33,2.23,7,.9,1.67,1.65,3.53,4.82,4.33,3.15.8,13.83.94,13.83.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m159.34,372.75l-30.26,1.7s-1.77-.35-1.06-1.78c4.66-1.28,31.76-2.29,31.76-2.29l-.43,2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m425.63,353.06l7.59-3.11s1.18-.37,1.94-2.75c.75-2.37,1.21-10.12,1.43-11.78.22-1.66.19-2.16,2.11-2.22s2.71.43,2.71.43l.29.56-4.8,24.14-13.03,1.35,1.76-6.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m426.85,353.31s5.17-1.51,7.18-2.26c2-.75,2.64-.74,3.16-6.77.52-6.01,1-9.63,1.49-10.42s3.02.34,3.02.34c0,0,1.03,7.01.88,11.03-.07.65-.12,1.11-.12,1.11,0,0-3,.41-3.28.56.04,1.47-.21,7.96-.25,9.03-.04,1.07-.23,3.41.69,3.36.93-.05,1.65,0,1.65,0,0,0-.2,2.54-2.08,2.75-1.88.21-9.51,3.2-10.1,4.01-.58.81-3.47-1.1-3.47-1.1l1.22-11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m369.45,357.69h-.82s1.73-1.31,2.95-10.06,4.64-24.93,16.34-31.57c11.37-6.45,21.63-1.91,23.64-.95,3.61,3.15,8.43,12.55,8.95,13.48.52.94,0,4.34.46,7,.47,2.66,2.96,13.5,2.96,13.5,0,0,2.6,3.65,2.92,4.22s2.25,12.72,2.25,12.72l-4.17,5.78-.85.38-.45-6.12-42.66-.12-11.52-8.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m378.47,370.53l-4.01.05.58-12.88s-.31-4.49.8-10.26c1.1-5.75,5.7-28.73,22.81-27.99,16.49.72,22.85,25.87,23.07,29.33l.04.63s1.75,10.88,1.85,16.67c-1.71-.04-12.65-.85-12.65-.85l-32.17,6.23-.33-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m162.09,325.65s-4.48,10.23-5.29,13.44c-.81,3.22.65,8,3.14,13.14,2.48,5.13,21.52-32.55,21.52-32.55l33.56,3.87,13.56,26.19s2.68,1.12,2.89,7.01c.21,5.91,1.38,25.46,1.4,25.89.01.31,4.33-1.94,6.59-3.15.78-.42,1.22-1.58,1.05-2.76-.59-4.01-1.88-12.74-2.19-15.1-.41-3.1-2.81-5.54-2.81-5.54,0,0-.79-7.05-2.05-12.51s-1.44-8.64-1.35-12.81c.1-2.25-1.34-4.79-2.14-6.63-.81-1.85-9.11-13.62-13.64-17.42-2.5-2.02-16.04-2.96-17.76-3.04-1.07-.05-10.77-.6-20.3,4.6-5.88,3.21-10.81,8.86-16.14,17.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m164.8,381.11l-4.9.1s-2.35-8.16.03-28.98,13.36-40.32,35.75-39.39c16.7.69,35.01,22.62,35.77,43.91.96,16.13,1.15,21.54,1.15,21.54l-1.18.37-6.94,1.26-59.68,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m228.66,367.8c.84,24.06-12.55,44.4-30.43,45.29-18.49.92-34.45-19.17-35.08-44.72-.62-25.34,14.14-45.26,32.41-44.68,17.68.56,32.27,20.23,33.11,44.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m218.34,367.89c.54,16.23-8.56,29.79-20.56,30.23-12.27.44-22.79-12.95-23.24-29.84-.44-16.8,9.27-30.18,21.45-29.95,11.91.22,21.82,13.42,22.35,29.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m216.47,367.9c.49,14.82-7.83,27.18-18.78,27.55-11.17.38-20.74-11.83-21.15-27.2-.41-15.3,8.42-27.5,19.51-27.32,10.87.17,19.93,12.22,20.41,26.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m214.57,367.92c.44,13.38-7.08,24.51-16.96,24.82-10.06.31-18.65-10.68-19.03-24.5-.37-13.76,7.56-24.77,17.55-24.63,9.81.13,17.99,11,18.43,24.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "199.63 394 195.67 394.13 194.13 342.27 198.06 342.32 199.63 394"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "178.12 370.98 177.97 365.5 214.98 365.27 215.16 370.56 178.12 370.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "181.38 351.57 184.12 347.76 212.03 384.22 209.43 388.07 181.38 351.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "185.38 388.57 182.41 384.76 208.04 348.15 210.88 351.91 185.38 388.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m192.62,368.11c.03,1.06-.58,1.93-1.36,1.94-.78,0-1.45-.85-1.48-1.92-.03-1.07.58-1.94,1.37-1.94.78,0,1.44.85,1.47,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m203.88,368.01c.03,1.05-.56,1.91-1.33,1.92-.77,0-1.42-.84-1.45-1.9s.57-1.92,1.33-1.92,1.42.84,1.45,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m196.7,362.29c-.78,0-1.43-.85-1.46-1.91-.03-1.06.57-1.92,1.35-1.92s1.43.86,1.46,1.91c.03,1.06-.57,1.91-1.34,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m197.17,377.72c-.78.01-1.43-.84-1.47-1.9-.03-1.06.57-1.93,1.35-1.95.78-.01,1.43.84,1.46,1.9.03,1.06-.57,1.93-1.35,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m199.62,368.05c.06,2.07-1.11,3.77-2.63,3.78-1.52.02-2.81-1.65-2.87-3.74-.06-2.08,1.12-3.77,2.65-3.78,1.52,0,2.79,1.66,2.86,3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m420.51,366.11c1.29,19.71-7.08,36.24-18.98,36.84-12.22.61-23.37-15.76-24.57-36.45-1.2-20.56,7.92-36.81,20.06-36.43,11.82.37,22.21,16.46,23.49,36.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m413.59,366.17c.85,13.27-4.82,24.3-12.81,24.59-8.13.29-15.49-10.62-16.31-24.34-.81-13.65,5.2-24.56,13.29-24.41,7.95.15,14.98,10.94,15.83,24.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m412.34,366.18c.77,12.12-4.41,22.17-11.7,22.41-7.4.25-14.1-9.7-14.85-22.18-.74-12.43,4.73-22.38,12.1-22.26,7.26.12,13.68,9.96,14.45,22.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m411.07,366.19c.7,10.93-3.99,19.99-10.56,20.19-6.67.21-12.69-8.75-13.37-19.98-.67-11.19,4.24-20.16,10.89-20.07,6.55.09,12.34,8.96,13.04,19.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "401.89 387.43 399.26 387.51 396.65 345.25 399.27 345.28 401.89 387.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "386.92 368.63 386.65 364.18 411.26 364.03 411.54 368.36 386.92 368.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "388.47 352.85 390.17 349.75 409.86 379.51 408.24 382.64 388.47 352.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "392.27 382.94 390.18 379.84 406.11 350.03 408.11 353.1 392.27 382.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m396.44,366.32c.05.87-.32,1.57-.85,1.58-.52,0-.99-.69-1.04-1.56-.05-.87.33-1.58.85-1.58s.98.7,1.04,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m403.93,366.26c.05.86-.32,1.56-.83,1.57-.51,0-.97-.69-1.02-1.55-.05-.86.32-1.56.83-1.57s.97.69,1.02,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m398.97,361.58c-.52,0-.98-.7-1.03-1.56s.32-1.56.84-1.56c.52,0,.98.7,1.03,1.56.05.86-.32,1.56-.84,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m399.75,374.16c-.52,0-.98-.69-1.03-1.55-.05-.87.32-1.57.84-1.58s.98.69,1.03,1.55-.32,1.57-.84,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m401.09,366.28c.1,1.69-.63,3.07-1.64,3.08-1.01.01-1.92-1.35-2.02-3.05-.1-1.69.63-3.07,1.64-3.08,1.01,0,1.91,1.36,2.02,3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m325.24,284.24s-1.47,8.51-1.37,21.88c.15,18.46.99,29.2,2.35,44.4.4,3.27,1.25,9.01,1.71,10.89"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 148.66,
    y1: 318.46,
    x2: 161.68,
    y2: 326.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m368.63,357.69h6.41s-.26,14.07-.26,14.07h0c.06,1.44-.6,2.6-1.49,2.62l-132.97,2.3-1.16-8.16s5.16-.75,8.05-.9c2.87-.14,71.79-2.22,90.45-3.04,17.95-.79,29.61-2.47,30.97-6.9Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 425.72,
    y1: 306.78,
    x2: 415.39,
    y2: 319.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m426.85,353.31c.33.57,2.25,12.72,2.25,12.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m416.71,305.23c.27,4.18-2.01,7.44-5.13,7.28-3.14-.16-5.91-3.73-6.18-7.96-.27-4.23,2.07-7.47,5.2-7.25,3.11.22,5.83,3.77,6.11,7.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m399.23,252.16s6.92,2.24,11.2,3.94c4.25,1.68,4.43,1.85,4.43,1.85,0,0-4.26,2.94-8.55,4.72h-.82s-2.98-2.52-4.47-4.49c-1.5-1.98-1.8-6.01-1.8-6.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m434.18,293.34l-3.58.22c-.26.02-.45.35-.44.8l.03,4.12c0,.55.29,1.04.61,1.07l2.41.16h0c.79.05,1.16.05,1.38-1.86.11-.97.31-2.39.23-3.54-.04-.54-.34-.99-.65-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m383.11,300.22c.33,2.99-1.35,5.56-3.75,5.75s-4.66-2.11-4.99-5.13,1.38-5.59,3.8-5.75c2.41-.16,4.62,2.14,4.95,5.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "m386.85,299.8c.09.79-.22,1.47-.7,1.52l-13.57.91c-.5.04-.97-.57-1.07-1.38h0c-.09-.81.23-1.5.73-1.54l13.57-.86c.48-.04.94.57,1.04,1.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "m318.05,300.48c.31,3.21-1.68,5.93-4.46,6.09-2.79.15-5.32-2.35-5.63-5.59-.31-3.24,1.72-5.96,4.51-6.08,2.78-.12,5.27,2.38,5.58,5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "m322.36,300.11c.09.85-.29,1.57-.84,1.61l-15.66.71c-.57.04-1.11-.63-1.2-1.5h0c-.09-.87.3-1.6.88-1.64l15.66-.66c.55-.04,1.07.63,1.16,1.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m235.51,288.05s-.58,7.18-.05,18.4c.96,20.25,2.9,35.15,5.66,48.03,1.35,5.84,4.98,11.33,4.98,11.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m311.5,233.28s-6.66,1.11-11.43,2.61c1.74.21,11.17.02,11.17.02l.26-2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m389.98,273.46s2.86-11.78-6.66-16.41c-9.71-4.72-21.59-8.72-36.27-11.89-15.14-3.26-44.59-6.27-59.02-4.64-17.64,5.24-29.55,16.89-35.32,20.76-5.85,3.92-13.51,12.94-21.15,21.4-1.05,1.16-1.88,2.09-2.56,2.83-.79.88-.18,2.77.87,2.72l10.13-.49,14.47-.46,26.1-.93,41.75-1.59s25.89-.34,39.05-1.14c12.79-.77,34.49-4.11,34.49-4.11l.67-1.63-6.57-4.41Zm-70.63,9.5l-77.24,2.18.63-8.61c.05-.62.26-1.16.61-1.51.81-.81,2.75-2.51,7.27-5.59,7.04-4.81,27.26-20.34,42.96-23.91,16.04-3.65,30.42-.6,30.42-.6l-4.64,38.03Zm43.66-1.02c-8.81.67-32.21.72-32.21.72l1.52-36.91c26.5,3.05,46.54,10.59,46.54,10.59l6.34,23.49s-13.55,1.45-22.19,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m261.61,286.3c-.11,1.21.33,4.16.38,4.68s-.33,2.19-.87,2.73-2.6-1.29-2.6-1.29l3.09-6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m261.61,286.3s-.31,1.44-.65,3.45c-.35,2.01.16,3.96.16,3.96,0,0-2.69,1.41-4.62,1.29s-2.78.45-3.69-.95,4.69-11.4,4.69-11.4l4.12,3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m257.42,285.4c.02.28.07,2.31-.42,3.2-.49.89-3.1,5.3-3.64,5.58s-.75-.53-.75-.53l.68-4.96,3.53-4.21.6.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m254.58,283.94c1.01,1.27.08,2.08.08,2.08,0,0-1.95,2.2-2.71,3.13-.77.93.48,4.25.66,4.5,1.12-1.21,3.55-6.82,3.93-7.5.38-.68.35-4.48.35-4.48l-2.32,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m254.6,284.32c2.49,1.46,8.87,2.32,10.44,2.43,1.57.11,3.66-1.44,4.09-2.6s-2.74-.59-2.74-.59l-10.93-.16-.86.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "m253.3,281.67c-.71-3.16,2.65-12.83,7.88-12.49,2.35.03,5.12.95,5.9,2.1.77,1.15.58,8,.58,8l-.53,2.23-13.82.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "m261.18,269.17c2.78.2,4.49.68,4.83,3.08.34,2.4.38,11.3.38,11.3,1.99-.56,3.37-.3,3.38-2.03.01-2.24-.25-6.99-.74-8.96-.49-1.97-3.68-3.26-7.85-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m260.15,276.68c-2.54.31-2.73,3.93-2.02,3.85,1.09-.13,7.11-.51,8.22-.34,1.52.23,3.39.82,3.39.82l-.14-3.51s-1.91-.83-3.35-.94c-3.05-.24-6.11.12-6.11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m260.66,284.2c-1.77.08-4.48.39-5.51.33-1.32-.08-1.85-2.87-1.85-2.87,0,0,5.55-.94,8.27-.99,1.66-.03,3.9-.24,4.78-.18,1.91.15,3.42.79,3.42.79,0,0-.09,3.75-1.82,3.55s-5.53-.73-7.29-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m383.31,257.05s6.95,3.09,11.95,6.49,6.83,4.41,5.59,7.37-4.31,6.96-4.31,6.96l-7.03,1.07-6.2-21.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "m383.31,257.05s6.95,3.09,11.95,6.49,6.83,4.41,5.59,7.37-4.31,6.96-4.31,6.96l-7.03,1.07-6.2-21.89Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-42",
    cx: 123.67,
    cy: 360.88,
    rx: 4.18,
    ry: 5.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m8.65,365.14c.27,1.79.36,2.69.36,2.69,0,0-4.34,1.21-7.39,1.25,1.57,1.34,6.72,1.43,19.12,2.02,12.4.58,57.59,1.14,60.08,1,2.49-.14,4.62-.14,7.11,1.92s9.66,4.48,12.05,5.23c2.39.75-8.63-10.28-8.63-10.28,0,0-14.57-3.38-20.73-3.04s-61.96-.79-61.96-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m74.96,318.37c0-2.58-2.22-4.06-7.84-4.16-5.62-.1-48.5.94-50.66,1.08-2.17.15-4.74,3.61-4.64,4.71.1,1.1,1.83,2.74,1.14,4.14s-.96,3.84-.96,3.84l36.29,3.15,26.68-12.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m17.53,316.29s-1.86.26-3.07.65c-1.21.39-2.64,3.07-2.64,3.07,0,0,3.89,1.6,4.76,2.08s-.14,2.9-1.61,4.15-2.98,1.75-2.98,1.75c0,0,.22,7.83,2.16,9.23,1.13.66,8.05.97,18.44.97s25.45-.09,27.48-.22c2.03-.13,7.09-7.74,7.83-9.09.75-1.35,4.2-9.38,4.28-11.03s1.34-2.21-11.47-2.21-43.19.65-43.19.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m15.06,328.58s-.74,5.28,2.12,7.4c1.13.65,6.58.91,6.71.91,7.05.61,33.04.24,35.44,0,3.77-.38,7.53-7.18,7.53-7.18l-2.25.09s-3.68,5.45-5.41,5.89c-1.73.43-18.22.84-23.59.83-5.37,0-15.57-.7-17.01-.61-1.43.09-1.9-5.24-1.9-5.24l-.87-.95-.78-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m29.07,322.95s.35,8.84,2.77,13.56h3.07s-3.42-6.37-3.19-14.62c-.47.29-2.65,1.06-2.65,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m23.2,323.04s1,10.23,3.51,13.47h-3.68s-2.55-8.91-2.51-13.98c1.38.38,2.68.51,2.68.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m15.06,328.58s3.47.79,22.46.94c19,.14,28.78-1.24,28.78-1.24,0,0-4.35-2.36-5.07-5.88-.29-2.48,11.36-4.55,11.36-4.55l2.37.52c0,1.7-8.09,11.33-8.09,11.33,0,0-18.35.95-33.41.69-14.63-.25-18.09-.88-18.09-.88l-.31-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m46.83,323.3c.04,1.65-3.85,6.5-3.85,6.5h2.03s2.9-4.28,2.99-6.71c-.17-.04-1.17.21-1.17.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m44.06,330.18s-2.81,5.54-5.8,6.66c1.73.37,2.38-.34,2.38-.34,0,0,3.33-2.91,4.37-6.72l-.95.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m58.35,323.3c-.13.91-3.9,6.19-5.59,6.71.91,0,2.79-.49,2.79-.49,0,0,3.86-3.11,4.13-6.44.22-.34-1.33.22-1.33.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m55.36,330.01s-4.54,5.84-6.45,6.75c2.86-.17,2.47-.25,2.47-.25,0,0,4.8-4.72,5.63-6.72-.13-.22-1.64.22-1.64.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m42.75,320.11l4.22-1.73,25.62-.52s-2.86,2.16-10.05,2.98c-.1,1.22-2.5,2.44-4.19,2.46-1.69.02-14.02,0-14.02,0l-4.5-1.44,2.93-1.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "62.54 320.84 41.33 321.06 41.17 321.61 62.32 321.42 62.54 320.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "m32.72,319.59l-2.58-1.21h-15.08c0,1.35,3.38,2.77,3.38,2.77,0,1.66.74,2.15,3.69,2.15h8s1.48-.77,3.45-.77-.87-2.94-.87-2.94Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "17.18 320.52 39.55 320.84 37.64 321.61 18.45 321.14 17.18 320.52"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-122",
    cx: 37.64,
    cy: 321.22,
    rx: 5.59,
    ry: 3.59,
    transform: "translate(-7.8 1.01) rotate(-1.39)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-120",
    cx: 37.64,
    cy: 321.22,
    rx: 4.6,
    ry: 2.41,
    transform: "translate(-7.8 1.01) rotate(-1.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m181.6,243.07s10.05-2.65,14.7-3.22,8.06-1.19,8.06-1.19v-1.37s8.06-.57,14.51-.85c6.45-.28,41.57,0,41.57,0,0,0-16.06-1.62-32.28-1.8s-23.33-.02-27.78-.01-15.23,4.97-18.77,8.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "m633.83,379.57c49.65,0,229.89,24.15,237.96,29.21,12.14,7.61-81.02,15.71-188.67,15.71-47.19,0-119.33-25.15-182.07-36.42-62.74-11.28,121.47-8.49,132.78-8.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m815.2,364.86c.34,18.68-3.08,38.77,6.97,44.82,5.08.12,18.04,0,21.7-1.04,9.52-1.07,21.68-18.2,21.04-42.62-.64-24.22-12.7-43.4-26.53-43.01-2.22.06-22.2.72-24.21,1.73-10.11,5.05.69,21.09,1.03,40.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m793.68,366.05c.46,22.99,12.82,42.56,28.05,43.58,15.74,1.05,28.3-18.01,27.59-42.43-.71-24.22-14.21-43.4-29.69-43.01-14.98.37-26.4,19.04-25.94,41.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m802.44,366.23c.34,15.51,8.72,28.56,18.93,29.09,10.44.54,18.71-12.17,18.26-28.31-.45-16.06-9.34-28.93-19.67-28.83-10.1.1-17.86,12.63-17.52,28.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m804.03,366.27c.31,14.16,7.98,26.05,17.29,26.51,9.5.46,17.02-11.11,16.62-25.8-.4-14.62-8.49-26.36-17.9-26.3-9.22.07-16.31,11.5-16.01,25.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m805.64,366.3c.28,12.78,7.21,23.49,15.61,23.88,8.55.39,15.31-10.04,14.95-23.25-.36-13.16-7.63-23.75-16.11-23.71-8.32.04-14.73,10.35-14.45,23.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "819.6 391.37 822.97 391.53 821.73 341.96 818.4 341.98 819.6 391.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "836.73 369.56 836.59 364.33 805.16 363.76 805.27 368.82 836.73 369.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "833.01 350.98 830.5 347.31 808.59 381.91 810.99 385.61 833.01 350.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "831.42 386.31 833.76 382.7 810.21 347.46 807.99 351.03 831.42 386.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m824.29,366.69c.03,1.02.59,1.85,1.25,1.87s1.19-.8,1.16-1.82c-.03-1.02-.59-1.86-1.25-1.87-.67-.01-1.18.8-1.16,1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m814.72,366.49c.02,1.01.57,1.83,1.22,1.85s1.16-.79,1.14-1.8c-.02-1.01-.57-1.84-1.23-1.85-.65-.01-1.16.79-1.14,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m820.53,361.08c.66,0,1.17-.8,1.15-1.81s-.58-1.84-1.24-1.84-1.17.8-1.15,1.81c.02,1.01.58,1.84,1.23,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m820.89,375.83c.66.02,1.18-.79,1.15-1.8-.03-1.02-.58-1.85-1.24-1.87-.66-.02-1.17.79-1.15,1.8.02,1.01.58,1.85,1.24,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m818.34,366.56c.05,1.98,1.13,3.61,2.42,3.64s2.3-1.56,2.25-3.54c-.05-1.99-1.14-3.62-2.43-3.64-1.29-.02-2.29,1.56-2.24,3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m567.03,379.09l9.18.33.62-2.15s14,.9,14.54,0,2.49-1.94,4.43.48c1.94,2.42,4.28,2.87,16.8,4.24,12.52,1.37,43.62,2.46,43.62,2.46l-.31-9s-93.23-7.41-93.7-7.21,4.59,10.08,4.59,10.08l.23.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m647.19,373.34l1.29,4.94,10.21,4.68,63-17.82-33.94-64.06s-42.81-4.78-54.35,1.65c-11.53,6.43,13.79,70.61,13.79,70.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m674.04,375.62c.1,18.68-5.82,38.71,4.15,44.88,5.07.18,20.29.24,23.96-.75,9.53-.95,21.91-17.92,21.58-42.35-.33-24.23-12.15-43.56-25.98-43.35-2.22.03-22.21.44-24.23,1.42-10.18,4.92.42,21.1.52,40.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m850.73,384.56s2.69,2.6,8.17,1.84c5.48-.76,7.59-6.83,7.59-6.83l-13.03.75-2.74,4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m748.13,388.06s.85,2.27,35.92,1.37c35.07-.9,65.81-4.68,65.81-4.68,0,0,13.43-2.85,13.92-3.73s-119.05,2.03-119.61,2.14-4.62,2.68-4.62,2.68l8.58,2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m716.68,397.23l30.89-.44,1.3-4.12,4.29-1.23.89-1.31,16.73-.5s-18.93-2.07-25.68-3.94c-6.75-1.87-31.29-.42-31.29-.42v6.96l2.87,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m743.62,378.92l-3.58.96-.49,5.96s12.33-.4,40.52-.4,71.4-3.05,71.4-3.05c0,0,16.83-.83,20.9-2.05s3.25-5.41,3.76-8.98-102.7-.44-102.7-.44l-29.81,8.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m743.62,378.92l32.99.96s30.77-.01,60.99-1.87c30.23-1.85,36.97-2.52,36.97-2.52l1.55-4.14v-8.8s0-9.84-10.7-12.35c-10.7-2.52-76.73-1.68-83.73-.84-7.01.84-38.08,29.57-38.08,29.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m866.19,298.52s3.77,2.32,6.08,4.15c2.31,1.83-.66,6.45-.66,6.45l-3.3,1.83s-5.61-9.03-5.61-10.74,3.49-1.68,3.49-1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m862.86,296.46s1.54.51,2.57,1.17c1.03.66.77,2.44.61,3.24s-1.69,1.43-1.69,1.43l-2.22-4.63.74-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m858.9,299.58c5.71,3.73,3.64,33.22-4.76,39.41s-74.33,0-74.33,0c0,0-22.72-43.84-20.42-46.79,2.3-2.95,99.51,7.38,99.51,7.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m782.27,310.78c9.9.62,76.5.16,82.65.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m786.99,306.4c9.9.62,62.4.4,68.55.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m787.26,320.5c9.9.62,76.5.16,82.65.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m791.38,315.23c9.9.62,62.4.4,68.55.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m787.26,329.27c9.9.62,76.5.16,82.65.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m791.98,324.89c9.9.62,62.4.4,68.55.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m792.24,338.99c9.9.62,76.5.16,82.65.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m796.36,333.72c9.9.62,62.4.4,68.55.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m781.7,312.1c9.9.62,76.5.16,82.65.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m786.42,307.73c9.9.62,62.4.4,68.55.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m786.68,321.82c9.9.62,76.5.16,82.65.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m790.81,316.55c9.9.62,62.4.4,68.55.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m786.68,330.6c9.9.62,76.5.16,82.65.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m791.41,326.22c9.9.62,62.4.4,68.55.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m791.67,340.31c9.9.62,76.5.16,82.65.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m795.79,335.04c9.9.62,62.4.4,68.55.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m863.45,300.06s2.23,3.28,3.7,5.81c1.47,2.53,1.85,4.19,1.85,4.19,0,0,3.46-1.13,3.75-3.77.15.59.85,2.83.85,2.83l-1.81,6.06-5.71,12.72s-3.61-.37-3.57-.52.59-22.35.6-23.32.15-3.64.15-3.64l.19-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m863.09,301.02s2.81,4.15,4.24,6.58,1.18,4.2,1.07,4.91-2.74,12.95-2.74,12.95c0,0-3.54,13.82-4.3,15.04s-1.62,6.12-10.27,6.07c-8.65-.05-19.03-.19-19.03-.19l1.99-7.76s22.96,1.88,26.04-12.62,2.09-19.86,2.09-19.86l-1.44-4.36,2.33-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m833.21,344.15s18.07-.25,20.52-.75c2.45-.5,4.41-1.02,5.67-4.39,1.26-3.37,6.76-21.53,6.76-21.66s.75-5.65,0-7.52c-.75-1.87-3.24-2.53-3.24-2.53,0,0-5.55,21.13-8.12,25.21-2.57,4.08-8.37,5.7-13.69,6.61s-7.89,5.03-7.89,5.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m862.51,301.78s2.77,6,3.54,7.48.8,2.15,1.26,2.22c.12,2.09-.34,5.57-1.75,10.31-1.42,4.74-7.27,20.2-7.27,20.2,0,0-.22,1.37-3.59,1.7-3.37.33-19.1.96-19.1.96l.24-1.31s3.73.02,9.78-.12c6.04-.14,8.28-.57,9.97-.9s2.9-3.41,5.18-10.48c2.28-7.07,5.33-18.97,5.33-18.97l-.7-2.8-4.63-7.39,1.75-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m804.47,336.23s26.09-.24,34.35-.47c8.26-.24,10.57-.53,10.57-.53,0,0,2.77-3.95,4.43-8.32,1.65-4.37,4.75-16.41,4.94-18.24.19-1.83.89-1.69.89-1.69,0,0,1.95,7.51.69,12.6s-4.8,19.25-4.8,19.25c0,0-22.61,2.63-28.81,2.36-6.2-.27-17.77,1.89-20.36-.59-2.6-2.48-1.89-4.37-1.89-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m834.06,339.92s17.01-.17,18.46-1.45c1.45-1.28,6.38-16.87,6.38-16.87l4.87-2.2-1.07,1.27s-2.56,9.13-4.12,14.19c-1.56,5.06-3.58,6.88-4.47,7.12s-18.28.98-18.28.98l-1.77-3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m861.82,302.66l3.61,6.97s-.12,1.19-.29,2.53c-.17,1.34-.99,5.73-1.37,7.24-.38,1.51-2.72,1.8-3.44,2.36s-1.43,1.29-1.43,1.29h-.92s.85-2.11,1.28-4.06c.44-1.95.7-8.43.7-8.43,0,0-.88-1.05-1.06-1.29s-.19-2.12-.62-2.73c-.44-.61-.46-1.54-.46-1.54l3.31-2.35h.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m809.55,340.33c.26.26.41-.15.41-.15,0,0-1.1-1.8-1.6-2.31s-.46-.99,1.05-.79c1.51.2,5.05,1.02,10.7,1.3s6.47-.24,6.86-.58.5-.88.5-.88c0,0,11.03.08,16.79-.19,5.76-.28,6.75-1.54,6.75-1.54,0,0,.43,1.14,1.22,1.42s1.46-.79,1.46-.79l4.29-12.76h.92s-4.02,11.26-4.93,14.14-3.71,3.63-7.22,3.73c-3.51.1-11.15,0-11.15,0,0,0-24.08,1.44-25.5.97-1.42-.47-.55-1.55-.55-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m835.6,340.92l.23,2.41.25,2.95s-25.64.68-32.34.51-14.51-3.15-16.83-9.91c-2.32-6.76-12.99-22.63-16.14-24.84-3.15-2.21-19.26-12.1-19.26-12.1l3.57-.14,12.43,2.59,15.66,5.34,17.21,23.26,7.43,10.46,27.77-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m786.93,322.08l14.19,21.52c.42.64,1.14,1.03,1.91,1.03h32.8v-1.31l-30,.03c-1.25,0-2.42-.62-3.12-1.66l-11.18-16.69-5.56-5.43.96,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m787.74,318.16s10.55,14.85,12.44,17.72,4.81,7.09,4.81,7.09h30.84l-.23-2.04h-25.5s-2.78-2.33-3.79-4.08c-1.01-1.75-10.11-17.51-10.11-17.51l-10.64-4.01,2.18,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m790.71,310.61l6.37,9.53s9.28,16.76,10.61,18.21c1.33,1.45,2.12,2.24,2.12,2.24l.29.32s-.9-.04-2.63-2.08c-1.04-1.23-10.63-18.03-10.63-18.03l-1.18-.63s-7.22-2.34-7.52-2.39-.91-.57-.91-.57c0,0-5.4-6.14-5.98-6.46s-1.46-.33-1.46-.33l2.58-1.17,8.32,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m781.11,304.31s8.53,5.34,9.6,6.3c-.81,0-11.38-.2-11.38-.2l-15.71-8.98,4.69.85,12.8,2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m787.97,326.37s10.76,17.2,11.98,18.56c1.21,1.36,3.15,1.41,6.83,1.38s42.94-.59,47.49-1.01,4.82-1.64,6.07-4.88,5.51-15.47,5.51-15.47l2.25-2.16-2.25,20.91s-2.72,5.2-8.81,5.39-64.27.56-64.27.56c0,0-4.45-20.63-7.45-22.6-3-1.97-13.64-15.33-13.64-15.33l.51-1.67s3.03,1.11,7.8,7.25c4.77,6.14,8,9.06,8,9.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m757.01,301.08l11.51,5.37s6.44,4.1,7.14,4.6,7.28,8.88,7.28,8.88l5.03,6.43-5.4-4.5-5.27-6.77-4.53-4.48-14.93-4.9-.82-4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m751.15,299.58l8.36,1.5s15.9,2.64,19.19,2.98,5.64.55,5.64.55c0,0,27.66.15,37.2.21s36.28.19,36.28.19l.16-5.1-112.37-8.37,5.54,8.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m856.65,304.61l1.17.4s1.81-.72,3.51-1.98,2.24-1.72,2.55-2.82c.31-1.1.21-3.53-1.69-4.33s-1.86,5.07-1.86,5.07l-3.68,3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "m879.8,326.62c.02,4.49-.3,18.58.18,20.75s-.54,12.05-.54,12.05l-7.64-13.6,6.54-20.14,1.47.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m879.37,313.22c.99,1.55.6,13,.06,19.04-.53,6.04-.37,11.38-.38,13.67-.01,2.29-1.19,1.53-1.74,0s-1.39-4.58-1.46-7.98,0-23.73,0-23.73l3.52-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m878.39,314.75s.46.44.57,1.5.11,10.68,0,11.37-.83,1.45-1.11,1.6c-.42.77-2.09,3.4-5.74,3.73-3.64.33-5.98,1.75-5.65,0,.33-1.75,2.66-12.9,3.28-14.91.62-2,2.81-3.46,2.81-3.46l5.84.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m835.83,353.21l18.22-.36s4.84-.27,9.3-.23c4.46.04,7.67,5.71,7.67,5.71l-6.64-1.89s-8.36-.29-10.96-.23c-2.59.06-15.85.15-15.85.15l-1.97-1.18.23-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m835.83,354.01s13.78-.4,19.62-.56c5.84-.16,9.78-.26,11.65.93,1.87,1.19,3.63,3.1,5.77,6.9,2.14,3.8,1.99,5.63,1.99,5.63,0,0-1.03.52-.95,1.85-4.04-4.48-5.9-9.29-9.47-9.06s-32.38.82-32.38.82l3.77-6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m865.43,358.52s2.92,1.95,5.24,4.32,3.1,5.2,3.24,5.93.23,4.01-.68,4.42-6.21.45-6.21.45l-1.59-15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m780.89,377.38s14.23-.27,36.13-.68c21.91-.41,50-3.07,50-3.07,0,0,.17-13.06,0-13.83s-1.37-1.29-6.44-1.29-65.72,1.13-65.72,1.13c0,0-11.9,1.31-13.97,2.94-2.07,1.63,0,14.79,0,14.79Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 798.24,
    y1: 360.42,
    x2: 797.93,
    y2: 375.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 811.27,
    y1: 359.9,
    x2: 810.95,
    y2: 374.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 824.29,
    y1: 359.37,
    x2: 823.98,
    y2: 374.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 837.32,
    y1: 358.85,
    x2: 837,
    y2: 373.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 850.34,
    y1: 358.32,
    x2: 850.03,
    y2: 373.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m781.49,364.3v11.94l-.6,1.13h-7.18s-9.17-3.32-11.47-4.72c-2.3-1.4,14.18-9.42,14.18-9.42l6.2-2.34-1.13,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "m722.48,320.84l10.29,5.31s-.02,12.85-3.15,16.64c-3.13,3.8-6.3,7.37-6.45,11.75s5.22,13.9,31.48,9.44c26.26-4.45,46.6-6.45,46.6-6.45l34.59-3.17v-6.63s-30.68.12-33.82.04-4.53-3.38-5.91-5.53c-1.38-2.15-15.74-23.91-23.34-31.64-12.52-7.69-61.95-11.5-73.54-5.05,2.53,5.3,23.26,15.28,23.26,15.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "m722.48,320.84l10.29,5.31s-.02,12.85-3.15,16.64c-3.13,3.8-6.3,7.37-6.45,11.75s5.22,13.9,31.48,9.44c26.26-4.45,46.6-6.45,46.6-6.45l34.59-3.17v-6.63s-30.68.12-33.82.04-4.53-3.38-5.91-5.53c-1.38-2.15-15.74-23.91-23.34-31.64-12.52-7.69-61.95-11.5-73.54-5.05,2.53,5.3,23.26,15.28,23.26,15.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "m716.08,306.54c2.32-1.29,9.27-1.47,12.69-1.07s8.45,2.16,13.65,4.3c5.2,2.14,7.29,1.84,5.27,2.62s-11.56.34-14.89.7-3.54.58-3.54.58c0,0-6.13-2.48-12.55-3.63l-4.27-.98s15.1,4.81,16.77,6.24,3.59-.92,9.68-.51c6.1.41,15.65,0,18.45.51s-3.98-3.8-9.19-5.26c-5.2-1.47-13.33-4.03-19.3-5.21-5.97-1.17-12.31.21-13.92,1.18-1.61.97-4.97,4.02-4.97,4.02l6.11-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m712.12,308.31c2.76,2.22,14.42,4.45,17.09,7.01.5,1.93-3.52,15.23-3.52,15.23,0,0-14.69,3.81-20.23-2.56-5.54-6.37-5.68-16.42-5.68-16.42,0,0,7.64-7.55,12.34-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "m702.74,317.37s3.75,5.55,4.63,7.42c.88,1.87,1.05,2.64,1.05,2.64,0,0,1.91-2.04,5.77-2.04s10.39.92,11.33,2.47c.94,1.55.89,7.77.89,7.77,0,0-3.09,13.63-.55,15.85,2.54,2.22,11.09,5.11,11.09,5.11l3.74,1.04c5.96,1.56,10.59,1.74,16.06.27,13.77-3.72,16.96-4.45,16.96-4.45,0,0-44.11,20.33-48.46,21.99s-13.52,1.21-13.52,1.21c0,0-5.64-35.25-11.15-44.17-5.51-8.92-6.19-16.86-6.19-16.86l8.36,1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m727.27,350.18s-.69.51-.57-6.49c.12-7,1.85-18.88,2.87-22.38s2.16-5.58,3.58-5.94,18.79.98,18.79.98c0,0,15.21,1.18,17.57,1.42,2.36.24,3.89.16,4.56.71s9.67,11.48,10.59,12.79.46,2.03-1.9,1.97-49.18-2.69-49.18-2.69c0,0-.99,7.31-1.68,11.01-.69,3.71-4.03,7.85-4.63,8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m772.76,317.26s-18.01-2.69-30.43-3.27c-12.41-.58-13.29-1.01-14.74,4.98s-4.57,17.75-4.07,27.69c.44,5.08,2.4,6,4.86,7.03s8.55,2.89,8.55,2.89c0,0-7.59-3.02-9.18-4.55-1.59-1.53-1.43-1.92-1.27-5.44.16-3.51.65-13.12,1.95-19.66,1.3-6.54,1.89-9.5,3.16-10.45s3.74-1.17,5.01-1.04,36.82,2.73,36.82,2.73l-.67-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m732.88,316.47s2.53-.18,8.64,0c6.11.18,25.6,1.88,28.49,2.11s6,4.82,6,4.82l2.87,7.77s-5.38.46-11.35,0c-5.97-.46-37.49-2.02-37.49-2.02l-.84-.28s.89-6.04,1.39-8.35,2.29-4.06,2.29-4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m714.94,375.44h4.64s5-13.11,6.48-15.36,2.25-2.8,3.41-2.03,8.9,3.96,13.07,4.83c4.18.88,5.99.66,10.22-1.1,4.23-1.76,17.25-6.99,20.11-8.08,2.86-1.09,7.64-.05,9.61.34s4.52.99,4.52.99c0,0-45.83,23.95-52.2,25.05-6.37,1.1-20.99-1.79-20.99-1.79v-2.93l1.13.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m709.26,378.86s1.38,9.46,1.92,13.37.77,4,2.32,4.59c1.54.59,3.18.42,3.18.42,0,0-1.85-9.37-1.74-10.01s25.1-.91,25.1-.91l-.49-.49-24.05-4.82-6.24-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m708.76,377.26l.49,1.59s2.91,6.35,5.68,6.97c2.77.62,24.61,0,24.61,0,0,0,1.78-4.26,2.79-5.73s7.44-5.04,7.44-5.04l7.75-3.92,4.73,1.52s9.61-5.11,16.58-8.44c6.97-3.33,10.92-4.49,16.04-4.57,5.11-.08,40.98-.68,40.98-.68v-5.33s-36.3.04-42.08.63c-5.78.59-9.69,2.26-16.34,5.05-6.65,2.78-27.13,13.13-27.13,13.13,0,0-10.43,5.04-11.61,5.61-3.3-.13-26.95-1.39-26.95-1.39l-2.97.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m646.76,371.14l.43,2.2,1.82-.58s-1.24-12.51-.3-25.28c.94-12.77,7.4-30.95,24.46-30.95s24.26,14.75,29.79,28.93c5.53,14.18,5.8,30.77,5.8,30.77h5.71l.46-.79s-3.32-22.76-8.46-37.59-15.61-26.7-29.66-26.7-20.29,4.71-25.37,12.98c-5.07,8.26-8.26,24.78-8.46,31.68s3.77,15.33,3.77,15.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m730.44,295.83s16.53,2.68,20.71,3.75c4.18,1.07,9.09,3.34,9.09,3.34,0,0,8.89,4.79,10.19,6.28s-1.4.57-1.4.57c0,0-12.18-2.01-19.03-3.07-6.85-1.05-18.4-2.47-23.05-2.5s-10.47.4-10.47.4l-11.72-11.68,25.68,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m696.15,291.55l-22.24-2.42c-.34-.04-.64-.25-.78-.56l-3.58-7.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m706.72,293.69s7.28,4.85,11.01,7.39c3.73,2.55,2.74,3,2.74,3,0,0-2.74,1.06-4.79,1.68-2.05.62-5.1,2.8-7.96,2.43s-8.27-2.72-10.08-8.61c-1.8-5.88.56-7.56.56-7.56l8.52,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m744.46,297.35l11.34,3.14s13.19,6.38,15.62,8.86c.14.7-.57.34-.57.34,0,0-9.37-6.45-15.21-8.6-5.84-2.16-8.09-1.99-8.09-1.99,0,0-20.45-3.35-28.59-4.15s-16.73-1.74-16.73-1.74l-9.91-1.1.17-2.29,60.35,6.01-8.37,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m698.89,292.76l13.81,13.81s4.04-2.78,6.74-2.94c2.7-.16,17.01.71,23.11,1.59,6.09.87,28.87,4.13,28.87,4.13l1.35,1.27s-13.41-2.06-14.52-2.22-11.58-1.59-16.74-2.3c-5.16-.71-17.06-1.77-20.55-1.48s-9.02,4.11-9.02,4.11l-17.53-17.17,4.49,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m795.29,281.92s9.23.33,21.74,1.45c12.5,1.12,23.89,1.66,30.2,4.97,6.32,3.32,10.58,7.13,10.58,7.13,0,0,1.33-.32,3.31,0s3.95,3.13,1.05,5.94c-2.9,2.81-5.52,3.21-5.52,3.21,0,0-67.88-.48-73.24-.61s-24.46-3.74-27.23-4.13c-2.77-.39-3.83-.53-3.83-.53,0,0-18.62-4.2-25.38-6.07-6.76-1.87-22.97-4.25-34.22-7.32-11.24-3.07-9.58-5.04-9.58-5.04l20.34,1.44,74.07,2.28,17.71-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "m710.74,283.87c25.71,4.1,37.77,7.61,51.54,8.58,13.77.97,65.9.24,75.77,0,9.87-.24-21.07-5.57-26.68-6.26-5.6-.68-8.44-3.29-8.44-3.29-2.28-.93-86.41-.64-95.08-.97-8.67-.33-38.75-2.15-38.75-2.15,0,0,26.93,2.55,41.65,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m667.68,279.74s3.18-.83,29.46,3.1,47.62,13.56,49.38,14.48,7.28,2.26,7.28,2.26c0,0-39.95-6.7-54.92-8.03-14.98-1.33-31.2-1.93-31.2-1.93v-9.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m740.43,245.41s4.43.98,14.69,6.98c10.26,6,41.19,29.67,41.19,29.67,0,0,6.1.63,6.63.84s-1.54,1.19-8.66.92c-7.12-.27-15.17-.45-15.17-.45,0,0-30.19-23.15-41.24-28.35-11.05-5.21-92-12.58-92-12.58,0,0,21.19-3.62,40.46-4.23,19.27-.61,54.11,7.2,54.11,7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m742.54,246.96s-7.39-6.12-17.42-8.43c-10.03-2.31-35.54-1.41-35.54-1.41,0,0,28.39,3.6,34.6,4.84,6.21,1.24,18.36,5.01,18.36,5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m631.4,234.82s27.84.17,46.02.67c18.17.5,41.24,4.4,47.41,5.48,6.17,1.08,11.94,4.32,13.28,4.75.52.32-17.94,5.94-17.94,5.94l-80.44-9.77-8.33-7.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m641.09,242.58l-2.1.33s-8.41-7.44-30.12-4.67c-21.71,2.78-41.19,7.47-41.19,7.47,0,0-.11-2.53.76-3.53.87-1,26.68-6.66,28.68-6.98,2-.33,14.19-1.83,22.63-2.07,8.44-.24,17.96,3.05,19.32,4.84s2.03,4.61,2.03,4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "m638.98,242.92s6.98-1.18,42.45-.54c35.47.64,59.45,3.95,59.45,3.95,0,0,16.26,4.96,53.39,37.49-6.71-.55-72.31-1.21-72.59-1.43-11.03.05-18.65-.9-18.65-.9-15.81-3.55-36.17-2.67-36.17-2.67l-28.98-34.78,1.1-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "m638.98,242.92s6.98-1.18,42.45-.54c35.47.64,59.45,3.95,59.45,3.95,0,0,16.26,4.96,53.39,37.49-6.71-.55-72.31-1.21-72.59-1.43-11.03.05-18.65-.9-18.65-.9-15.81-3.55-36.17-2.67-36.17-2.67l-28.98-34.78,1.1-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m514.94,330.23s-.6,5.21-.7,8.2.64,7.74.96,10.03c.32,2.29,4.7,13.18,8.7,15.9,4,2.72.85-17.88.85-17.88l-9.81-16.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m536.52,317.35c-8.9,0-13.66,5.97-16.26,16.21s-.77,19.89-.77,19.89l8.62,4.43,29.45,7.2,1.21-4.46s-1.38-1.04-1.63-1.83c-3.2-10.31-3.86-39.55-20.62-41.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m540.91,366.05c.06,13.55-10.33,33.02-2.7,34.17,3.7.56,15.58.25,17.54.31,8.51.97,15.46-13.89,15.26-33.08-.2-19.03-7.36-34.21-15.74-34.05-1.42.03-17.55-1.16-18.83-.31-6.06,4.01,4.4,18.16,4.47,32.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m523.37,365.74c.07,18.06,6.61,33.55,14.84,34.48,8.51.97,15.46-13.89,15.26-33.08-.2-19.03-7.36-34.21-15.74-34.05-8.11.16-14.44,14.72-14.36,32.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m528.11,365.96c.06,12.19,4.5,22.51,10.02,23.02,5.65.52,10.22-9.39,10.1-22.08-.12-12.62-4.83-22.81-10.42-22.82-5.47-.01-9.76,9.76-9.7,21.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m528.97,366c.06,11.13,4.12,20.53,9.15,20.97s9.3-8.58,9.19-20.12c-.1-11.49-4.39-20.78-9.49-20.81-4.99-.03-8.92,8.88-8.86,19.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m529.84,366.04c.05,10.04,3.72,18.52,8.26,18.9,4.63.39,8.36-7.75,8.27-18.13-.09-10.34-3.95-18.72-8.53-18.77-4.51-.05-8.05,7.99-8,18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "537.2 385.86 539.02 386.01 538.74 347.07 536.93 347.05 537.2 385.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "546.64 368.88 546.6 364.77 529.6 364.04 529.62 368.02 546.64 368.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "544.77 354.25 543.44 351.34 531.32 378.32 532.59 381.25 544.77 354.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "543.64 381.98 544.93 379.17 532.46 351.28 531.23 354.06 543.64 381.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m539.93,366.51c0,.8.3,1.46.66,1.48s.65-.62.64-1.42c0-.8-.3-1.46-.66-1.48-.36-.02-.65.62-.64,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m534.75,366.27c0,.79.29,1.45.65,1.46s.64-.61.63-1.4-.3-1.45-.65-1.46-.63.61-.63,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m537.94,362.07c.36.01.64-.62.64-1.42s-.3-1.45-.66-1.46-.64.62-.63,1.41.3,1.45.65,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m538.02,373.66c.36.02.64-.61.64-1.41,0-.8-.3-1.46-.66-1.48-.36-.02-.64.61-.64,1.41s.3,1.46.66,1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m536.71,366.36c.01,1.55.58,2.85,1.28,2.88s1.26-1.2,1.25-2.76c-.01-1.56-.59-2.85-1.29-2.88-.7-.03-1.25,1.21-1.24,2.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "646.76 371.14 647.19 373.34 650.91 378.29 653.33 379.8 653.33 380.55 556.62 370.05 555.97 364.53 558.77 360.63 646.76 371.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m656.5,279.38l-6.43.36s-12.92,11.91-12.99,42.46c-.08,30.55,16.81-3.28,16.81-3.28,0,0,9.75-14.78,21.84-11.74,12.09,3.04,27.02,10.19,27.02,10.19,0,0,3.1-3.75,4.25-4.81s5.12-4.24,5.12-4.24l-.68-1.13s-14.01-13.73-14.6-14.29-1.62-1.34-1.62-1.34l-20.1-2.32-2.02-.37-4.01-9.07-12.6-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "m656.5,279.38l-6.43.36s-12.92,11.91-12.99,42.46c-.08,30.55,16.81-3.28,16.81-3.28,0,0,9.75-14.78,21.84-11.74,12.09,3.04,27.02,10.19,27.02,10.19,0,0,3.1-3.75,4.25-4.81s5.12-4.24,5.12-4.24l-.68-1.13s-14.01-13.73-14.6-14.29-1.62-1.34-1.62-1.34l-20.1-2.32-2.02-.37-4.01-9.07-12.6-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m518.27,302.83s-2.06,11.59-3.33,27.4c-.14,3.01.64,17.58,4.17,20.62.28,0-1.03-4.48.38-15.93,1.41-11.45,5.06-22.71,17.11-22.71,6.62,0,15.3,7.06,18.86,23.29,3.56,16.23,3.31,25.15,3.31,25.15l6.68.64s26.99-.76,47.73,2.72c20.75,3.48,27.67,7.15,27.67,7.15h5.91s-.19-15.27.64-23.93,2.93-20.08,10.95-28.29,20.62-10.31,29.88-4.39,10.43,8.92,10.43,8.92l4.08-6.08s-9.36-13.58-23.09-13.58c-22.61,0-28.57,16.26-30.64,16.32s-6.09-3.89-6.09-3.89l-62.96-12.05-37.12-4.6-24.57,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "m518.27,302.83s-2.06,11.59-3.33,27.4c-.14,3.01.64,17.58,4.17,20.62.28,0-1.03-4.48.38-15.93,1.41-11.45,5.06-22.71,17.11-22.71,6.62,0,15.3,7.06,18.86,23.29,3.56,16.23,3.31,25.15,3.31,25.15l6.68.64s26.99-.76,47.73,2.72c20.75,3.48,27.67,7.15,27.67,7.15h5.91s-.19-15.27.64-23.93,2.93-20.08,10.95-28.29,20.62-10.31,29.88-4.39,10.43,8.92,10.43,8.92l4.08-6.08s-9.36-13.58-23.09-13.58c-22.61,0-28.57,16.26-30.64,16.32s-6.09-3.89-6.09-3.89l-62.96-12.05-37.12-4.6-24.57,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m516.89,297.32v1.58s2.47-.22,1.54,3.26-.49,9.22,3.31,9.93,3.8-5.37,11.67-6.29,14.86,4.29,17.47,8.84c2.61,4.56,4.73,4.29,7.71,4.02,2.98-.27,8.74-4.18,13.51-4.4,4.77-.22,36.84.49,50.24.6,13.4.11,21.44,2.07,23.71,4.07,0,0-.38-4.19.37-10.69.75-6.5,2.25-9.98,2.25-9.98,0,0,2.33-6.14,3.03-7.12.71-.98,2.65-4.05,2.65-4.05v-6.02s.28-1.24-1.25-1.59c-.35-.08-9.03,8.21-9.03,8.21,0,0-9.19-2.41-14.8-1.9-10.77.97-27.96-1.58-39.86-1.16-21.08.75-41.24-1.69-41.24-1.69,0,0-3.78-8.65-3.78-10.69s3.33-6.05,3.33-6.05l11.04-14.54s-14.35,3.24-18.38,10.17c-4.02,6.94-9.14,15.64-10.84,19.41s-4.31,5.2-6.15,5.58c-1.84.38-6.51,10.49-6.51,10.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "m516.89,297.32v1.58s2.47-.22,1.54,3.26-.49,9.22,3.31,9.93,3.8-5.37,11.67-6.29,14.86,4.29,17.47,8.84c2.61,4.56,4.73,4.29,7.71,4.02,2.98-.27,8.74-4.18,13.51-4.4,4.77-.22,36.84.49,50.24.6,13.4.11,21.44,2.07,23.71,4.07,0,0-.38-4.19.37-10.69.75-6.5,2.25-9.98,2.25-9.98,0,0,2.33-6.14,3.03-7.12.71-.98,2.65-4.05,2.65-4.05v-6.02s.28-1.24-1.25-1.59c-.35-.08-9.03,8.21-9.03,8.21,0,0-9.19-2.41-14.8-1.9-10.77.97-27.96-1.58-39.86-1.16-21.08.75-41.24-1.69-41.24-1.69,0,0-3.78-8.65-3.78-10.69s3.33-6.05,3.33-6.05l11.04-14.54s-14.35,3.24-18.38,10.17c-4.02,6.94-9.14,15.64-10.84,19.41s-4.31,5.2-6.15,5.58c-1.84.38-6.51,10.49-6.51,10.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m542.86,255.41s-9.63,15.61-12.3,23.76c.45-.31.94-1.32.94-1.32,0,0,3.67-6.08,5.73-9.05s6.57-9.04,6.57-9.04l-.95-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m654.36,279.39s18.55.51,20.24.59c-3.42-.33-7.74-1.16-7.74-1.16,0,0-17.41-28.32-27.12-36.93-9.72-8.61-25.04-6.64-37.6-4.82-12.56,1.82-48.1,10.18-48.1,10.18,0,0-7.55,1.17-10.91,6.29-.52,1.03-.14,7.14-.14,7.14,0,0,3.24-4.82,5.05-5.49s15.3-4.5,21.66-5.74c6.36-1.24,26.78-7.13,39.54-7.44,12.77-.31,17.37-.62,21.4,3.98,4.03,4.6,23.74,33.4,23.74,33.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m545.91,256.87s.19-1.56,6.42-3.89c6.23-2.33,33.89-9.21,53.56-11.51,6.98-.81,19.49-1.11,24.05,2.79,8.73,7.47,24.82,35.03,24.82,35.03l-1.65.17-51.4-35.48s-42.46,8.32-44.3,8.98-11.51,3.9-11.51,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "m557.41,252.97s-7.89,9.8-10.86,14.3c-2.97,4.5-1.32,13.15,0,14.57,1.32,1.42,9.39,1.92,9.39,1.92l39.64,1.37,27.73,1.1,11.19,1.28,10.82.32,4.03-13.93-12.47-17.65s-6.81-12.82-16.91-12.82c-4.96,0-8.58-.08-10.84,0s-3.24.34-3.24.34l-7.23.86-23.65,4.38-4.7.98-12.91,2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "m548.03,255.19s-13.55,18.16-16.52,22.66c-2.97,4.5,8.37,12.81,9.69,14.23,1.32,1.42,14.74,2.48,14.74,2.48l39.64,1.37,27.73,1.1,11.19,1.28,10.82.32,4.03-13.93-12.47-17.65s-6.81-12.82-16.91-12.82c-4.94,0-8.69-.12-10.95-.04-2.36.09-3.12.37-3.12.37l-7.23.86-23.65,4.38-4.7.98-22.29-5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m549.2,282.39s31.17,1.31,41.79,1.83,23.41.41,23.41.41c0,0,.94,1.54,4.57,2.15-18.74-.28-55.23-1.87-63.33-2.15-8.1-.28-9.09-1.69-9.09-1.69l2.65-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m568.87,250.21s-4.27,7.41-9.74,18.57c-5.47,11.16-6.29,14.17-6.29,14.17h6.95s3.94-15.81,4.7-18.38c.77-2.57,7.27-15.11,7.27-15.11l-2.9.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m601.71,244s-4.98,13.4-6.04,18.04c-2.09,9.2-4.69,22.18-4.69,22.18l8.88.41s1.23-9.81,3.31-20.39c2.07-10.58,4.79-20.95,4.79-20.95l-6.25.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m557.41,252.97s-11.29,12.6-13.51,17.48c-1.41,3.11,1.77,10.25,2.65,12.48.44.03,2.92,0,2.92,0,0,0-2.79-5.42-3.57-8.95-.77-3.53.42-4.39,2.63-7.8s9.65-13.5,9.65-13.5l-.77.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m642.19,287.68h1.89l3.58-15.58,4.5,6.95,2.61.26-6.95,7.64c-.78.86-1.89,1.35-3.05,1.35h-2.16l-.41-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m557.9,253.09s11.97-2.8,17.05-3.93c5.08-1.13,20.25-3.72,26.63-4.8s12.49-1.02,17.77-.62c5.28.4,8.1,1.33,11.89,5.65s20.92,29.66,20.92,29.66l1.73.33s-4.05-4.72-8.73-11.66c-4.68-6.94-11.09-16.41-13.68-19.06s-4.43-4.93-13.25-5.55c-10.63-.74-16.97.84-16.97.84l-29.48,5.49-13.59,3.25-.29.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m565.93,348.04s1.73.42,9.08,1.5,35.23,6.73,43.66,8.61c8.43,1.88,22.8,11.92,23.67,12.14s-1.49.85-1.49.85l-76.27-9.84s8.27-6.11,1.35-13.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m653.34,376.55c.12,23,10.91,42.71,24.5,43.9,14.05,1.23,25.52-17.68,25.19-42.11-.33-24.23-12.15-43.56-25.98-43.35-13.39.2-23.83,18.74-23.71,41.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m661.16,376.83c.1,15.51,7.43,28.66,16.54,29.3,9.32.66,16.87-11.96,16.67-28.1-.19-16.06-7.98-29.04-17.21-29.05-9.02-.02-16.12,12.43-16.01,27.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m662.58,376.88c.1,14.16,6.79,26.14,15.11,26.7,8.48.57,15.35-10.92,15.17-25.61-.17-14.62-7.25-26.46-15.66-26.5-8.24-.04-14.72,11.31-14.63,25.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m664.02,376.93c.09,12.79,6.14,23.58,13.64,24.06,7.64.49,13.8-9.86,13.65-23.08-.15-13.16-6.52-23.83-14.09-23.89-7.44-.06-13.3,10.18-13.21,22.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "676.17 402.16 679.18 402.36 678.7 352.78 675.73 352.76 676.17 402.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "691.75 380.55 691.69 375.31 663.62 374.39 663.66 379.45 691.75 380.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "688.67 361.92 686.47 358.23 666.46 392.57 668.55 396.31 688.67 361.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "686.8 397.23 688.93 393.65 668.34 358.15 666.31 361.69 686.8 397.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m680.67,377.53c0,1.02.5,1.86,1.09,1.88.6.02,1.07-.79,1.06-1.81-.01-1.02-.5-1.86-1.1-1.88-.59-.02-1.07.79-1.06,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m672.13,377.23c0,1.01.49,1.84,1.07,1.86.58.02,1.05-.78,1.04-1.79s-.49-1.84-1.07-1.86-1.05.78-1.04,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m677.39,371.88c.59.02,1.06-.79,1.05-1.8,0-1.01-.49-1.84-1.08-1.86s-1.06.79-1.05,1.8.49,1.84,1.08,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m677.52,386.64c.59.03,1.06-.77,1.05-1.79,0-1.02-.5-1.86-1.09-1.89-.59-.03-1.06.78-1.05,1.79,0,1.01.49,1.86,1.08,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m675.36,377.34c.02,1.98.96,3.62,2.11,3.67s2.08-1.53,2.06-3.52c-.02-1.99-.97-3.63-2.13-3.66-1.15-.04-2.07,1.54-2.05,3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m564.58,361.29s4.48-4.4,6.53-6.31c2.05-1.9,2.94-1.81,7.14-.92,4.2.89,22.53,4.29,32.23,5.92,9.7,1.63,12.08,2.29,16.75,4.34s13.2,6.3,13.62,6.81-5.36,0-9.84-.42-66.43-9.42-66.43-9.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m635.36,370.71c-.28-.03-17.61-2.49-25.02-3.52-13.06-1.82-27.57-4.01-31.58-4.76-6.89-1.29-10.23-1.85-11.27-2.02-.26-.04-.09-.4-.09-.4l.93-1.11c.45-.33,3.88-3.42,5.22-4.03.32-.15.69-.23,1.03-.23.94,0,1.38.66,2.61,1.45.88.56,2.25,1.38,3.78,2.17,3.59,1.84,5.13,1.88,18.7,3.83l13.51,1.91c10.44,1.51,12.42,1.96,13.09,2.03,1.64.17,7.38,3.08,9.31,4.05.17.09.03.47.03.47l-.26.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m568.7,359.07s3.94-3.37,5.22-3.96,2.39.99,6.53,3.12c4.14,2.13,6.06,2.24,23.84,4.81,17.78,2.56,20.4,3.09,22.09,3.26,1.5.15,7.57,3.19,8.93,3.88.05.03.03.11-.03.1-1.36-.17-6.84-.84-9.08-1.3-2.56-.52-41.68-5.71-48.03-7.05-6.35-1.34-9.48-2.86-9.48-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m593.2,285.79l-5.35,12.68s-.76,6.34-.55,22.18,2.08,32.12,2.08,32.12l.85,4.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m654.36,280.29v6.79s-1.24,1.05-3.06,4.88c-1.82,3.83-4.5,10.24-4.88,16.27-.38,6.03-1.05,42.58-1.44,49.37s-.67,14.28-.67,14.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m550.87,284.21s-2.16,2.57-5,3.6c-2.84,1.03-3.73,1.06-4.33,2.39-.6,1.33-3.37,8.35-3.37,15.66,0,1.57.85,7.09.85,7.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m529.95,291.52c-2.8-.1-5,3.62-6.07,8.21s-1.43,8.06.77,8.32,3.72-.87,4.75-3.67c1.02-2.81,1.84-6.58,2.45-9.08s-.51-3.72-1.89-3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m639.64,284.15l2.57,3.71c.54.78.52,1.82-.05,2.58l-2.05,2.76c-.3.4-.77.62-1.26.61l-3.99-.12-3.28-6.48s-2.21-2.28.13-3.62c2.34-1.34,7.92.56,7.92.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m640.19,277.97c0-2.91-4.2-8.83-7.84-9.47-3.64-.64-7.65.32-7.65.32,0,0-6.29,1.29-8.98,2.49-2.69,1.19-4.54,4.34-4.54,4.34v1l.32,1.94s.98,3.72,2.9,6.04c1.91,2.33,7.47,2.58,7.47,2.58h9.72s.86-2.29,2.83-2.62c1.97-.33,5.23-.43,5.23-.43,0,0,.96-3.32.56-6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m611.02,276.14l.48,2.44s2.44.36,9.65,1.04c7.21.69,7.21,1.32,11.4,1.7,4.19.38,7.85,0,7.85,0l-.2-3.35c-.15-.46-2.64-.25-3.12-.53s-1.48-.82-1.48-.82l-14.47-.1-10.11-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m613.66,276.25s9.83.53,15.17.75c5.34.21,6.76-.37,6.76-.37,0,0-2.99.1-9.48-.15-6.49-.25-12.45-.22-12.45-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m633.83,269.96s-.81-.75-5.44,0-10.9,2.15-10.9,2.15c0,0,7.21-2.15,10.84-2.92s5.5.78,5.5.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m611.18,275.64s.5-3.6,7.18-5.41c6.68-1.8,9.41-1.74,9.41-1.74,0,0-7.93,1.09-11.5,3.08-3.57,1.99-3.91,4.06-3.91,4.06h-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m558.19,252.7c-7.8,1.89-12.28,4.18-12.28,4.18,0,0-10.76,13.57-15.35,22.29l.07.33s7.09-12.22,14.51-20.91c.91-1.13,1.41-1.64,1.41-1.64,0,0,9.35-3.18,10.7-3.6s.93-.65.93-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m518.87,341.37c0-16.11,5.82-29.13,16.52-29.13s20.91,10.34,23.16,43.13c0,0-1.44,2.71-4.15-9.33-2.71-12.04-7.1-28.39-18.37-28.39-15.81,0-17.16,23.72-17.16,23.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m522.65,286.92c1.69-.33,5.85.24,6.32.89.47.65-7.16,8.57-7.77,9.08s-4.31.42-4.31.42c0,0,.56-5.25,1.03-7.12s3.04-2.95,4.73-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m527.02,288.39s-4.53-.52-5.05-.57-1.91.29-3.19,1.62c-.24.52,2.81.76,4.86.76s3.38-1.81,3.38-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "m522.65,286.92c1.69-.33,5.85.24,6.32.89s-7.16,8.57-7.77,9.08-4.31.42-4.31.42c0,0,.56-5.25,1.03-7.12s3.04-2.95,4.73-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m560.61,245.72l4.53-3.99s36.04-9.44,54.97-9.44c12.39-.51,22.06,5.65,24.9,10.19-1.26.06-3.93.1-3.93.1,0,0-6.2-9.04-18.87-9.04s-47.18,6.88-50.14,7.67c-2.96.8-4.09,3.58-4.09,3.58l-7.37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m838.09,285.59c7.19,1.35,19.72,9.88,19.72,9.88l4.39.43c-2.38-1.28-4.84-1.36-4.84-1.36-10.25-8.57-19.27-8.95-19.27-8.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m714.18,296.5s10.2,1.94,17.17,3.09c6.97,1.14,11.69,2.14,13.99,3.13s4.98,3.17,4.98,3.17l-5.41-2.55s-2.99-.56-12.66-1.62c-9.67-1.06-11.91-1.6-11.91-1.6l-6.16-3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m750.56,300.56s9.57,3.95,12.68,5.86c3.11,1.91,1.38,1.49,1.38,1.49,0,0-3.23-1.83-7.36-2.02-4.49-1.44-6.7-5.33-6.7-5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m708.76,377.26s21.55.73,24.8.93c3.25.2,5.57,0,5.57,0l23.74-11.61s13.33-6.26,18.24-8.44c4.91-2.17,6.57-2.57,10.68-2.9,4.11-.33,9.48-.4,9.48-.4l34.56-.84v-.8s-24.85.21-35.61.71c-10.76.5-14.17.79-18.06,2.78s-13.98,6.07-21.38,10.05c-7.39,3.98-21.9,10.85-21.9,10.85l-24.41-1.37h-5.71v1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m735.19,344.83c-.76-.44-1.71-.1-2.01.73s-.76,1.86-1.46,2.83l-.86,1.19c-.44.61-.32,1.45.28,1.9,1.09.83,3.15,2.16,6.59,3.53,5.7,2.27,9.82,2.53,12.15,2.6,2.33.06,10.66-1.35,13.42-3.19,2.76-1.84,4.17-3.79-1.96-3.28-4.26.36-7.11,0-16.54-2.54-1.57-.42-8.8-3.29-9.62-3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m712.7,307.91s-6.11,4.07-9.96,9.46c-.44.56-3.86,5.95-3.86,5.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m730.6,320.53s.93-2.33,1.27-2.65c.58-.37,1.22.55,1.22.55v.96s23.8,1.46,25.58,1.6,1.78-.82,1.78-.82l2.06.84-2.38-2.48h.82l3.57,3.57-31.85-2.15h-1.2l-.88.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m769.61,319.53l7.49,10.34-8.82-.66,1.28,1.47-34.53-1.99-4.98-.19v.66s49.81,3.32,51.23,3.32,1.66-.33,1.66-.33c0,0-8.67-11.05-9.58-11.95-.91-.9-3.71-1.85-3.75-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m744.31,322.08l-4.76-.47s2.55,5.33,8.14,7.54c-3.72-4.6-3.37-7.07-3.37-7.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m752.03,322.08s1.98,4.66,8.3,7.07c-1.04-1.16-3.06-4.29-3.06-4.29,2.02,2.21,6.74,5.36,6.74,5.36-2.76-2.97-4.23-7.57-4.23-7.57l-7.75-.57Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 780.07,
    y1: 370.36,
    x2: 868.27,
    y2: 367.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 780.34,
    y1: 365.14,
    x2: 867.34,
    y2: 362.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "m835.83,347.74c13.03-.12,19.08-.42,21.37-.77s4.02-2.89,5.7-8.21,3.78-13.09,3.78-13.09h2.1s-.73,3.46-1.04,4.88-.43,1.64,1.04,1.51,6.35-1.18,7.56-1.84,1.51-1.01,1.51-1.01c0,0-.95,5.19-1.43,9.2s-.52,5.96.91,8.73,2.07,7.57,2.03,11.37-3.24,12.83-3.24,12.83c0,0,.67-3.72-1.26-7.86-1.93-4.15-5.34-9.46-7.76-10.86-2.42-1.41-7.17-1.02-9.68-.89-2.51.13-21.58,1.48-21.58,1.48v-5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "m866.68,325.67c1.54-4.88,2.61-8,2.61-11.2v-3.56s2.68-.81,3.23-2.06.37-1.98.37-1.98c0,0,3.05,3.38,4.52,4.45,1.47,1.07,2.61,1.98,1.69,2.94s-5.55,2.31-7.09,3.05c-1.54.73-1.54,1.69-1.8,3.05-.26,1.36-1.5,5.64-1.5,5.64h-1.88l-.15-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m869.91,325.46s6.01-1.32,7.67-3.85c1.65-2.53,1.05-4.33,1.05-4.33,0,0-1.23-.3-3.7,0-2.47.3-3.52.75-3.88,1.47s-1.2,5.5-1.14,6.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m869.3,329.9l.6-3.9c1.99.23,7.07-2.94,7.07-2.94-.2.29-1.15,1.18-1.15,1.18.46.1,1.15-.1,1.15-.1-.07.59-6.39,2.88-6.39,2.88-.33,1.64-.1,2.33-.1,2.33,0,0,2.63-.16,3.84-.95-.46,1.08-5.02,1.51-5.02,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m761.13,301.35l14.1,7.91,2.11,1.36,9.59,11.47,4.6,2.93s-7.85-11.02-9.92-13.05-6.98-5.22-8.85-6.07c-1.87-.85-7.45-4.39-7.45-4.39l-4.18-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m858.58,305.01s2.52,4.6,2.92,5.56c1.13-.1,3.21-.2,3.41-.23.17-.7-2.25-5.7-3.16-6.96-.48.5-3.16,1.63-3.16,1.63Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 828.76,
    cy: 319.27,
    rx: 7.69,
    ry: 4.82,
    transform: "translate(-12.99 36) rotate(-2.47)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-126",
    cx: 828.76,
    cy: 319.27,
    rx: 6.33,
    ry: 3.24,
    transform: "translate(-9.52 25.91) rotate(-1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "m430.18,293.5c-92.85,0-132.35-13.95-132.35-13.95,0,0,31.34-79.07,53.27-79.57,21.92-.5,131.24-2.57,131.24-2.57,0,0,41.35,3.18,52.94,3.54s39.65,48.34,47.36,71.24c7.7,22.9-48.73,25.42-48.73,25.42l-103.72-4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m536.79,207.14c-15.46-.73-120.73-5.39-190.51-.03-1.02.08-1.96.55-2.61,1.34-8.13,9.92-24.57,42.27-31.05,55.28-1.26,2.53.58,5.49,3.41,5.49h250.95c2.65,0,4.52-2.66,3.56-5.13-7.5-19.49-26.12-48.22-30.77-55.26-.67-1.01-1.77-1.64-2.99-1.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "485.7 293.78 564.85 295.18 481.06 197.13 407.56 196.67 485.7 293.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "429.51 292.74 456.75 293.25 385.5 196.98 362.47 197.41 429.51 292.74"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m583.49,429.67s-27.43,4.84-28.59,4.55c.53,5.32-10.4,8.12-20.07,10.23-9.67,2.1-92.89,3.64-92.89,3.64,0,0-83.23-1.54-92.89-3.64-9.66-2.1-20.59-4.9-20.07-10.23-1.16.28-28.59-4.55-28.59-4.55,0,0-11.24,8.42-7.84,15.31,3.4,6.89,3.97,3.11,29.32,6.61,25.35,3.5,120.07,2.16,120.07,2.16,0,0,94.71,1.34,120.07-2.16,25.35-3.5,25.92.28,29.32-6.61,3.4-6.89-7.84-15.31-7.84-15.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m608.62,449.81s-1.17,6.87-3.27,9.79c-2.09,2.92-13.84,7.6-46.84,10.81s-116.57,4.68-116.57,4.68v-9.59l166.67-15.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "m441.94,372.46v79.17s86.35,10.98,118.97,1.94c32.63-9.04,33.27-15.49,18.93-49.68-14.34-34.18-73.11-44.64-83.1-46.42-9.99-1.78-54.8,14.98-54.8,14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "m545.01,462.76c23.88-1.63,38.48-5.32,38.48-5.32,0,0-5.13-6.74-12.11-8.34-6.98-1.6-11.87-3.06-17.89-2.98-6.02.09-26.56,4.66-41.56,4.66-15,0-69.98.72-69.98.72v14l103.07-2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "m441.94,460.16s57.67-.87,76.62-1.3c18.95-.43,21.26-.43,26.45,3.9-35.79,2.74-103.07,2.74-103.07,2.74v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m275.27,449.81s1.17,6.87,3.27,9.79c2.09,2.92,13.84,7.6,46.84,10.81,33,3.21,116.57,4.68,116.57,4.68v-9.59l-166.67-15.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "m441.94,372.46v79.17s-86.35,10.98-118.97,1.94c-32.63-9.04-33.27-15.49-18.93-49.68,14.34-34.18,73.11-44.64,83.1-46.42,9.99-1.78,54.8,14.98,54.8,14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m520.61,388.67c-.59,0-78.67,2.02-78.67,2.02,0,0-78.08-2.02-78.67-2.02s-9,2.52-9,2.52l7.99,6.05s1.34,1.01,5.47,1.43c4.12.42,74.21,1.27,74.21,1.27,0,0,70.09-.85,74.21-1.27,4.12-.42,5.47-1.43,5.47-1.43l7.99-6.05s-8.41-2.52-9-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m441.94,398.58c-1.41-.02-70.08-.86-74.07-1.26-3.55-.36-4.8-1.17-4.81-1.18l-5.8-4.39c2.98-.88,5.68-1.64,6.13-1.7.88.02,77.74,2,78.51,2.02.85-.02,77.71-2.01,78.71-2.02.36.06,3.04.82,6.01,1.7l-5.84,4.42h0s-1.27.8-4.78,1.16c-3.99.41-72.66,1.25-74.07,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m533.52,412.14c-2.86-.56-5.72-1.69-7.22-2.33-.67-.29-1.41-.41-2.13-.31-11.58,1.51-76.85,2.11-82.22,2.15-5.37-.05-70.64-.65-82.22-2.15-.73-.09-1.46.02-2.13.31-1.5.64-4.36,1.77-7.22,2.33-.34.07-.4.52-.09.67,3.6,1.67,7.07,7.13,11.6,7.45,4.9.34,74.41,1.8,80.06,1.92,5.65-.12,75.16-1.57,80.06-1.92,4.53-.32,8-5.78,11.6-7.45.31-.15.25-.6-.09-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m441.46,420.79c-17.53-.37-75.07-1.59-79.48-1.9-2.29-.16-4.45-2.08-6.55-3.94-.82-.73-1.61-1.43-2.42-2.04,2.12-.6,4.01-1.36,5.12-1.84.36-.15.72-.23,1.09-.23.11,0,.22,0,.33.02,11.58,1.51,75.17,2.1,82.38,2.17,7.24-.06,70.82-.66,82.41-2.17.11-.01.22-.02.33-.02.37,0,.73.08,1.09.23,1.11.48,3,1.24,5.12,1.84-.81.61-1.6,1.32-2.42,2.04-2.09,1.86-4.26,3.78-6.55,3.94-4.41.31-61.97,1.53-79.5,1.9h-.46s-.48,0-.48,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m522.18,399.4c-7.97,1.32-80.24,1.68-80.24,1.68,0,0-72.27-.36-80.24-1.68-.81,1.36-7.34,1.59-9.65,1.95,1.99,1.16,6.43,7.08,11.8,7.34,5.37.27,78.09,1.45,78.09,1.45,0,0,72.71-1.18,78.09-1.45,5.37-.27,9.81-6.18,11.8-7.34-2.31-.36-8.85-.59-9.65-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m441.94,408.78c-1.61-.03-72.76-1.18-78.02-1.44-3.29-.16-6.31-2.88-8.56-4.96,3.62-.38,5.71-.75,6.81-1.52,10.65,1.25,76.88,1.59,79.76,1.6,2.9-.01,69.13-.36,79.78-1.6,1.11.78,3.19,1.15,6.81,1.52-2.25,2.08-5.27,4.8-8.56,4.96-5.26.26-76.41,1.42-78.02,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "m338.88,462.76c-23.88-1.63-38.48-5.32-38.48-5.32,0,0,5.13-6.74,12.11-8.34,6.98-1.6,11.87-3.06,17.89-2.98,6.02.09,26.56,4.66,41.56,4.66s69.98.72,69.98.72v14l-103.07-2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "m441.94,460.16s-57.67-.87-76.62-1.3c-18.95-.43-21.26-.43-26.45,3.9,35.79,2.74,103.07,2.74,103.07,2.74v-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m534.42,379.48s-64.3.72-92.48.72-92.48-.72-92.48-.72l-5.84,3.84,19.29,3.07,1.34.99s46.25,1.89,77.68,1.89,77.68-1.89,77.68-1.89l1.34-.99,19.29-3.07-5.84-3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m441.94,428.26s-77.22-.66-91.4-2.56c1.61,2.42,7.17,5.56,7.17,5.56,0,0,18.25,2.23,84.23,2.23s84.23-2.23,84.23-2.23c0,0,5.56-3.14,7.17-5.56-14.18,1.9-91.4,2.56-91.4,2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m526.17,432.73c-25.98,1.95-84.23,1.69-84.23,1.69,0,0-58.25.25-84.23-1.69-3.8.85-13.53,2.79-13.53,2.79.66.34,3.88,1.53,9.56,1.86,25.07,1.45,88.2,1.78,88.2,1.78,0,0,63.13-.33,88.2-1.78,5.69-.33,8.91-1.52,9.57-1.86,0,0-9.73-1.95-13.53-2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m523.45,438.49c-19.89.51-81.51,1.98-81.51,1.98,0,0-61.62-1.47-81.51-1.98-8.38-.17-14.05-1.27-14.05-1.27,0,0,5.35,4,8.14,5.47.95.5,6.35.78,19.87,1.21,26.12.85,67.54.85,67.54.85,0,0,41.42,0,67.54-.85,13.52-.44,18.92-.71,19.87-1.21,2.79-1.47,8.14-5.47,8.14-5.47,0,0-5.67,1.1-14.05,1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m526.17,420.77c-2.06.54-11.41,1.5-20.93,1.41-29.52,1.62-63.3,1.62-63.3,1.62,0,0-33.78,0-63.3-1.62-9.52.09-18.87-.87-20.93-1.41-3.02,1.5-11.33,3.06-11.33,3.06.5.36,1.98,1.11,1.98,1.11,0,0,31.89,2.35,93.58,2.35s93.58-2.35,93.58-2.35c0,0,1.48-.75,1.98-1.11,0,0-8.31-1.56-11.33-3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m614.71,444.2c0,15.39-4.35,23.93-6.1,25.95-1.75,2.01-5.77,3.22-11.7,3.22-5.93,0-9.55-.8-10.36-1.01s0-9.91,0-9.91l28.16-18.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m269.18,444.2c0,15.39,4.35,23.93,6.1,25.95,1.75,2.01,5.77,3.22,11.7,3.22s9.55-.8,10.36-1.01,0-9.91,0-9.91l-28.16-18.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m441.94,376.1v6.94s100.46-2.83,100.46-2.83c0,0-17.43-17.48-41.36-21.62-23.93-4.15-59.1,10.86-59.1,10.86v6.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "m450.62,375.95c52.76,0,70.35-1.59,70.35-1.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m450.62,375.45c23.44.02,46.93.14,70.34-1.26,0,0,.03.33.03.33-11.71.89-23.44,1.18-35.17,1.47-11.73.27-23.46.39-35.19.45v-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m441.94,376.1v6.94l-100.46-2.83s17.43-17.48,41.36-21.62c23.93-4.15,59.1,10.86,59.1,10.86v6.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "m433.27,375.95c-52.76,0-70.35-1.59-70.35-1.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m433.27,376.45c-23.46-.2-46.95-.3-70.37-1.92,0,0,.03-.33.03-.33,11.69.78,23.43.96,35.15,1.14,11.73.16,23.45.17,35.18.12,0,0,0,1,0,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m559.9,310.38c-3.92-12.83-117.95,18.34-117.95,18.34h0s-114.04-31.17-117.95-18.34c-3.92,12.83,40.31,47.9,40.31,47.9,0,0,22.05,17.81,77.65,17.81h0c55.6,0,77.65-17.81,77.65-17.81,0,0,44.22-35.07,40.31-47.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m529.41,196.36s6.07.35,14.39,11.61c8.32,11.27,28.63,43.08,37.62,68.08l9,25,10.13,2.97s-1.81-7.47-18.28-44.05c-16.47-36.57-38.48-63.96-52.87-63.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m589.17,255.24s-1.42,1.65-1.42,6.27c0,4.62,2.31,13.69,2.31,13.69l4.52-5.76-5.41-14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m589.17,255.24s.96,18.83.89,19.95,3.61,1.47,3.61,1.47c0,0,14.24,2.68,21.03-.2,5.86-2.69,6.53-3.87,6.53-3.87v-5.16s-9.12-6.74-9.12-6.74l-22.94-5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m589.17,255.24l7.28,10.13c1.12,1.55,2.93,2.46,4.84,2.43l19.94-.36s-3.21-7.17-14.09-9.89-17.97-2.31-17.97-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m621.23,269.43s-5.94,1.75-7.35,5.36c1.07-.04,3.88-.46,5.7-.75.95-.15,1.65-.97,1.65-1.93v-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m621.23,272.59c-.8,2.54-2.05,5.87-9.1,7.22s-19.81,2.99-19.81,2.99l-2.26-4.68,3.61-1.47s13.21.28,16.71-.79l3.5-1.07,7.35-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m501.04,367.4c23.87,0,60.19,28.6,78.32,63.86,14.4-.69,2.71-15.1,2.71-15.1l-54.28-55.05-26.75,6.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m540.3,384.57c-3.91.98-11.16,2.02-13.84,2.38-.33.05-.4.48-.1.63,1.35.68,3.72,1.79,4.85,2.32.41.19.86.31,1.32.3,3.8-.03,12.47-.98,15.01-1.45.31-.06-1.05-.82-1.33-.97l-5.66-3.18c-.07-.04-.16-.05-.24-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m572.99,419.89s2.76,3.47,5.83,8.89c-2.52,1.32-20.57,3.84-29.08,4.55-8.51.71-11.27-1.1-12.37-2.13-1.1-1.02-1.65-2.13,1.58-3.94,3.23-1.81,6.06-3.07,6.06-3.07l27.98-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m536.23,416.88l5.42-3.92c.14-.1.31-.17.48-.19l23.78-2.87c.35-.04.7.1.92.38l4.94,6.28c.47.6.14,1.49-.61,1.63-2.55.48-9.47,1.69-16.27,2.65-9.64,1.36-10.84,1.55-13.92,1.16-1.72-.22-3.55-1.41-4.82-2.41-.88-.7-.84-2.05.07-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m557.69,399.18s4.59,4.43,8.15,9.43c-8.36.69-18.8,2.24-23.03,2.3-3.08.05-7.89-1.81-10.28-2.83-.73-.31-.92-1.25-.37-1.82,1.58-1.63,4.58-4.41,6.97-4.66,3.4-.35,18.56-2.43,18.56-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m556.77,398.19s-9.32,1.62-18,1.76c-5.6.09-8.91-1.24-10.56-2.19-.69-.4-.73-1.37-.08-1.83,2.2-1.57,6.77-4.68,8.84-4.94,2.78-.35,10.42-.63,10.42-.63,0,0,8.27,6.3,9.38,7.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m589.88,445.58s-6.3-3.49-9.15-7.17c-9.3-1.23-16.63,2-23.25,4.14-6.62,2.15-16.01,5.11-16.01,5.11l17.53,6.1,31.62-2.92-.73-5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m589.88,445.58s-6.6,3.33-22.83,5.03c-16.22,1.7,9.44,7.32,16.44,6.84s11.99-1.63,11.99-1.63l6.91-15.35-12.52,5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m501.04,367.4c21.9,2.43,57.24,19.92,86.38,72.8.92,2.06,7.12,15.53,7.12,15.53,0,0-.59-80.43-10.23-92.17-9.64-11.75-83.27,3.85-83.27,3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "m551.63,324.34c-2.91,5.34-44.91,21.95-63.24,28.67-18.33,6.72-23.98,12.83-12.37,11.91,11.61-.92,51.78-3.82,51.78-3.82,0,0,35.25-27.81,37.1-39.41,1.85-11.61-13.27,2.64-13.27,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "m605.96,315.42c12.89,25.06,15.27,29.55,15.27,71.99,0,42.44-3.03,50.11-3.03,50.11,0,0-10.24,7.85-18.63,8.6-5.96-.56-17.93-21.54-17.93-21.54,0,0-16.64-28.94-35.71-40.91-19.07-11.97-46.48-22.67-46.48-22.67l-2.71-3.52,63.95-21.67,33.84-29.73,11.42,9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "m564.29,358.29c20.83-.93,39.4-6.14,47.56,12.01,8.16,18.15,6.35,53.53,6.35,53.53l-53.91-65.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m608.62,369.49c5.99,9.77,9.58,46.44,9.58,54.34,0,7.9-16.75,4.47-20.25,2.39-3.5-2.08-5.45-9.04-5.45-9.04,0,0,1.64-5.71,15.46-21.82-.21-12.99-3.25-26.81.66-25.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m605.89,399.41s5.51-.3,7.42,4.86c1.68,4.55-1.66,15.62-1.66,15.62,0,0-11.53-10.42-15.14-6.2-1.31-3.64,5.4-7.62,5.4-7.62,4.2-2.51.44-4.58,3.98-6.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "m541.46,345.65s-33.75,9.48-41.01,11.23c-7.27,1.75-8.42-.58,1.21-4.08,9.63-3.5,40.75-12.92,40.75-12.92l-.94,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "m539.56,345.32s-31.75,9.2-38.51,10.83c-6.76,1.63-7.77.46,1.18-2.8s37.9-12.02,37.9-12.02l-.57,3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m496.75,357.47s32.16,6.79,58.15,31.11c17.55,16.42,29.47,34.67,35.36,44.8,2.84,4.87,8.29,7.61,13.9,7.01,6.04-.66,12.91-1.65,14.04-2.86-2.98,15.82-23.66,18.2-23.66,18.2,0,0,1.36-11.27-25.73-45.66-30.44-38.64-64.9-43.27-64.9-43.27l-7.16-9.32Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-55",
    cx: 604.24,
    cy: 416.39,
    r: 8.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m597.95,416.39c0,3.48,2.82,6.3,6.3,6.3,3.48,0,6.3-2.82,6.3-6.3,0-3.48-2.82-1.1-6.3-1.1-3.48,0-6.3-2.37-6.3,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "m546.11,428.26s13.88-.86,25.89-3.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m546.1,428.15c8.56-.96,17.42-2.12,25.9-3.57-6.29,1.85-12.82,2.8-19.34,3.4-2.18.19-4.36.34-6.54.38,0,0-.01-.21-.01-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "m544.2,417.32s10.92-.65,20.38-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m544.2,417.24c6.63-.72,13.82-1.62,20.38-2.7-4.96,1.41-10.1,2.12-15.23,2.57-1.71.14-3.43.25-5.15.29v-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "m540.98,405.86s9.4-.42,17.54-1.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m540.97,405.79c5.61-.5,11.96-1.16,17.54-1.9-4.3,1.05-8.71,1.55-13.12,1.86-1.47.1-2.94.15-4.42.17,0,0,0-.13,0-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m550.23,394.57s-6.77.36-13.54,1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m550.23,394.63c-3.99.36-9.59.92-13.54,1.21,4.38-.72,9.27-1.42,13.54-1.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m476.79,273.55h10.99c-13.94-4.92-29.79-8.05-45.05-8.63l34.06,8.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m489.87,269.98l-3.16-1.47-48.58-6.34-46.79-2.69-.03,1.73,45.89,2.3,5.52,1.4c14.72.56,29.99,3.5,43.56,8.12,1.25-.95,2.48-1.94,3.58-3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m489.87,269.98c-1.1,1.12-2.33,2.11-3.58,3.06.5.17,1,.34,1.49.51h9.77l-7.67-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m323.74,271.45c18.81-2.74,40.4-4.86,64.26-5.44,23.68-.57,45.13.5,63.87,2.31-.63-.5-1.25-.99-1.87-1.49-8.56-.99-17.6-1.81-27.09-2.4-10.26-.64-20.05-.95-29.33-1.01-.76-.74-1.52-1.47-2.28-2.21l.03-1.73-17.22.92c-3.37,1.25-6.75,2.49-10.12,3.74-7.27.83-13.12,1.45-17.17,1.87-4.55.47-7.66.78-12.14,1.44-4.24.63-7.72,1.29-10.11,1.77-.28.74-.56,1.48-.84,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m361.91,266.45c4.22-1.44,8.44-2.88,12.65-4.32,5.19-.19,10.37-.38,15.56-.58.82.96,1.65,1.92,2.47,2.88,5.39.34,10.78.69,16.17,1.03-5.59-.23-11.41-.34-17.44-.31-10.42.05-20.24.54-29.41,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m441.94,200.21s-65.99,1.52-94.61,3.31c-1.46-2.91,8.75-7.17,8.75-7.17,0,0,44.44-6.54,85.86-6.54v10.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m354.48,196.36s-6.07.35-14.39,11.61c-8.32,11.27-28.63,43.08-37.62,68.08l-9,25-10.13,2.97s1.81-7.47,18.28-44.05c16.47-36.57,38.48-63.96,52.87-63.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m294.72,255.24s1.42,1.65,1.42,6.27-2.31,13.69-2.31,13.69l-4.52-5.76,5.41-14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m294.72,255.24s-.96,18.83-.89,19.95c.07,1.12-3.61,1.47-3.61,1.47,0,0-14.24,2.68-21.03-.2-5.86-2.69-6.53-3.87-6.53-3.87v-5.16l9.12-6.74,22.94-5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m294.72,255.24l-7.28,10.13c-1.12,1.55-2.93,2.46-4.84,2.43l-19.94-.36s3.21-7.17,14.09-9.89c10.88-2.72,17.97-2.31,17.97-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m262.66,269.43s5.94,1.75,7.35,5.36c-1.07-.04-3.88-.46-5.7-.75-.95-.15-1.65-.97-1.65-1.93v-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m262.66,272.59c.8,2.54,2.05,5.87,9.1,7.22,7.05,1.35,19.81,2.99,19.81,2.99l2.26-4.68-3.61-1.47s-13.21.28-16.71-.79l-3.5-1.07-7.35-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m382.84,367.4c-23.87,0-60.19,28.6-78.32,63.86-14.4-.69-2.71-15.1-2.71-15.1l54.28-55.05,26.75,6.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m343.59,384.57c3.91.98,11.16,2.02,13.84,2.38.33.05.4.48.1.63-1.35.68-3.72,1.79-4.85,2.32-.41.19-.86.31-1.32.3-3.8-.03-12.47-.98-15.01-1.45-.31-.06,1.05-.82,1.33-.97l5.66-3.18c.07-.04.16-.05.24-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m310.89,419.89s-2.76,3.47-5.83,8.89c2.52,1.32,20.57,3.84,29.08,4.55s11.27-1.1,12.37-2.13,1.65-2.13-1.58-3.94c-3.23-1.81-6.06-3.07-6.06-3.07l-27.98-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m347.65,416.88l-5.42-3.92c-.14-.1-.31-.17-.48-.19l-23.78-2.87c-.35-.04-.7.1-.92.38l-4.94,6.28c-.47.6-.14,1.49.61,1.63,2.55.48,9.47,1.69,16.27,2.65,9.64,1.36,10.84,1.55,13.92,1.16,1.72-.22,3.55-1.41,4.82-2.41.88-.7.84-2.05-.07-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m326.2,399.18s-4.59,4.43-8.15,9.43c8.36.69,18.8,2.24,23.03,2.3,3.08.05,7.89-1.81,10.28-2.83.73-.31.92-1.25.37-1.82-1.58-1.63-4.58-4.41-6.97-4.66-3.4-.35-18.56-2.43-18.56-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m327.11,398.19s9.32,1.62,18,1.76c5.6.09,8.91-1.24,10.56-2.19.69-.4.73-1.37.08-1.83-2.2-1.57-6.77-4.68-8.84-4.94-2.78-.35-10.42-.63-10.42-.63,0,0-8.27,6.3-9.38,7.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m294.01,445.58s6.3-3.49,9.15-7.17c9.3-1.23,16.63,2,23.25,4.14,6.62,2.15,16.01,5.11,16.01,5.11l-17.53,6.1-31.62-2.92.73-5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m294.01,445.58s6.6,3.33,22.83,5.03c16.22,1.7-9.44,7.32-16.44,6.84-7-.49-11.99-1.63-11.99-1.63l-6.91-15.35,12.52,5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m382.84,367.4c-21.9,2.43-57.24,19.92-86.38,72.8-.92,2.06-7.12,15.53-7.12,15.53,0,0,.59-80.43,10.23-92.17,9.64-11.75,83.27,3.85,83.27,3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "m332.26,324.34c2.91,5.34,44.91,21.95,63.24,28.67,18.33,6.72,23.98,12.83,12.37,11.91-11.61-.92-51.78-3.82-51.78-3.82,0,0-35.25-27.81-37.1-39.41-1.85-11.61,13.27,2.64,13.27,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m277.93,315.42c-12.89,25.06-15.27,29.55-15.27,71.99s3.03,50.11,3.03,50.11c0,0,10.24,7.85,18.63,8.6,5.96-.56,17.93-21.54,17.93-21.54,0,0,16.64-28.94,35.71-40.91,19.07-11.97,46.48-22.67,46.48-22.67l2.71-3.52-63.95-21.67-33.84-29.73-11.42,9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m319.6,358.29c-20.83-.93-39.4-6.14-47.56,12.01-8.16,18.15-6.35,53.53-6.35,53.53l53.91-65.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m275.27,369.49c-5.99,9.77-9.58,46.44-9.58,54.34s16.75,4.47,20.25,2.39c3.5-2.08,5.45-9.04,5.45-9.04,0,0-1.64-5.71-15.46-21.82.21-12.99,3.25-26.81-.66-25.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m278,399.41s-5.51-.3-7.42,4.86c-1.68,4.55,1.66,15.62,1.66,15.62,0,0,11.53-10.42,15.14-6.2,1.31-3.64-5.4-7.62-5.4-7.62-4.2-2.51-.44-4.58-3.98-6.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m342.43,345.65s33.75,9.48,41.01,11.23c7.27,1.75,8.42-.58-1.21-4.08-9.63-3.5-40.75-12.92-40.75-12.92l.94,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m344.33,345.32s31.75,9.2,38.51,10.83c6.76,1.63,7.77.46-1.18-2.8-8.96-3.26-37.9-12.02-37.9-12.02l.57,3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m387.14,357.47s-32.16,6.79-58.15,31.11c-17.55,16.42-29.47,34.67-35.36,44.8-2.84,4.87-8.29,7.61-13.9,7.01-6.04-.66-12.91-1.65-14.04-2.86,2.98,15.82,23.66,18.2,23.66,18.2,0,0-1.36-11.27,25.73-45.66,30.44-38.64,64.9-43.27,64.9-43.27l7.16-9.32Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-55",
    cx: 279.64,
    cy: 416.39,
    r: 8.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m285.94,416.39c0,3.48-2.82,6.3-6.3,6.3s-6.3-2.82-6.3-6.3,2.82-1.1,6.3-1.1,6.3-2.37,6.3,1.1Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-98",
    cx: 441.94,
    cy: 357.47,
    rx: 18.69,
    ry: 11.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "m337.78,428.26s-13.88-.86-25.89-3.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m337.77,428.36c-8.72-.31-17.48-1.37-25.88-3.78,8.47,1.45,17.34,2.61,25.9,3.57,0,0-.01.21-.01.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m339.69,417.32s-10.92-.65-20.38-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m339.68,417.4c-6.86-.23-13.75-1.03-20.37-2.86,4.89.79,10.33,1.53,15.27,2.12,0,0,5.11.58,5.11.58v.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m342.91,405.86s-9.4-.42-17.54-1.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m342.91,405.92c-5.89-.12-11.8-.67-17.53-2.03,4.08.53,9.06,1.1,13.15,1.49,0,0,4.39.41,4.39.41,0,0,0,.13,0,.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m523.49,381.08c-55.2,2.82-110.61,3.45-165.77-.41,6.9.37,13.8.83,20.7,1.07,48.24,2.17,97.09,1.11,145.07-.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "m333.66,394.57s6.77.36,13.54,1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m333.66,394.52c4.53.11,9.07.49,13.53,1.31-3.92-.29-9.57-.85-13.54-1.21,0,0,0-.1,0-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m356.09,196.35h-1.61s-7.79,1.1-11.24,7.72c1.49-.27,4.09-.55,4.09-.55,0,0,1.3-3.44,8.75-7.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m441.94,200.21s65.99,1.52,94.61,3.31c1.46-2.91-8.75-7.17-8.75-7.17,0,0-44.44-6.54-85.86-6.54,0,3.03,0,10.39,0,10.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m580.58,274.02l-138.63-.46v-.12l-16.44.07-20.86-.07s.07.06.17.16l-101.5.43s-6.02,13.82-7.18,23.04c-.08.98,26.69,25.69,39.04,30.79,0,0,4.51.39,20.39,2.25,15.88,1.86,40.79,5.88,48.83,4.02,8.04-1.86,19.31-5.39,37.55-5.39s29.51,3.53,37.55,5.39c8.04,1.86,32.94-2.16,48.83-4.02,15.88-1.86,20.39-2.25,20.39-2.25,12.35-5.1,39.12-29.81,39.04-30.79-1.16-9.22-7.18-23.04-7.18-23.04Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-85",
    cx: 441.94,
    cy: 357.47,
    rx: 15.86,
    ry: 9.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-84",
    cx: 441.94,
    cy: 357.48,
    rx: 9.47,
    ry: 5.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m527.8,196.35h1.61s7.79,1.1,11.24,7.72c-1.49-.27-4.09-.55-4.09-.55,0,0-1.3-3.44-8.75-7.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m536.77,355.77c1.68-2.97,4.26-9.95,4.89-11.67l-.19-2.18,7.25-12.24v-1.84s7.06-3.9,18.34-12.15c11.28-8.25,20.7-18.64,20.7-18.64,0,0,3.61-1.01,7.84,1.71,4.23,2.72,5.99,7.24,5.99,7.24l.07.78c3.23,4.16,5.46,10.75,6.53,18.66.25,1.86.39,3.74.42,5.59v.02c.01.44,0,.86,0,1.28,0,.31,0,.62-.01.93-.28,17.15-3.79,18.42-3.79,18.42,0,0-.84-.23-3.23-1.37-2.39-1.14-6.82-2.77-28.87.93-22.04,3.7-35.43,6.88-35.43,6.88,0,0-2.44,1.04-.52-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m601.58,306.01s-1.76-4.53-5.99-7.24c-4.23-2.72-7.84-1.71-7.84-1.71,0,0-9.42,10.39-20.7,18.64-11.28,8.25-18.34,12.15-18.34,12.15v1.84s-7.25,12.24-7.25,12.24l.8,9.06,61.98-16.29-2.67-28.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m608.62,331.07c0,19.26-3.81,20.64-3.81,20.64,0,0-.84-.23-3.23-1.37-2.39-1.14-6.82-2.77-28.87.93s-35.43,6.88-35.43,6.88c0,0-2.44,1.04-.52-2.37,1.92-3.4,5.03-12.06,5.03-12.06,0,0,19.23-3.7,24.11-8.51,4.88-4.81,13.23-14.57,20.7-17.75,7.48-3.18,14.06-6.36,14.06-6.36l7.94,19.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m598.89,304.01c4.74,3.52,7.94,11.43,9.29,21.43,1.36,10.01-.68,20.4-3.38,24.88,1.62-23.04-3.06-37.89-8.04-36.58-4.98,1.31-.26-1.25,1.34-3.57s.78-6.16.78-6.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m583.37,323.58s5.76-1.66,8.71-1.87c2.95-.22,9.58,4.1,10.01,4.47s.65,6.32-3.02,11.23c-3.67,4.9-6.48,5.48-10.51,5.55-4.03.07-7.49-1.01-12.17-3.38-4.68-2.38-6.91-3.6-6.91-3.6l13.9-12.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m582.08,325.09s5.08-1.46,7.68-1.65c2.6-.19,8.44,3.62,8.82,3.93s.57,5.57-2.67,9.89c-3.24,4.32-5.71,4.83-9.27,4.89-3.55.06-6.6-.89-10.73-2.98-4.13-2.09-6.09-3.17-6.09-3.17l12.25-10.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m598.89,304.01s.72,4.68-3.59,7.43c-4.3,2.75-13.51,7.29-15.9,8.49-2.39,1.2-5.86,4.66-9.32,8.13-3.47,3.47-7.77,8.25-7.77,8.25l-18.88,5.38v2.99s22.11-6.21,22.11-6.21c0,0,8.01-8.61,12.31-13.03s16.49-11.23,19.84-11.95,1.2-9.46,1.2-9.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "568.98 337.4 583.56 344.67 604.8 341.8 604.46 344.02 583.49 346.93 567.05 339.25 568.98 337.4"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-49",
    cx: 586.61,
    cy: 332.21,
    r: 6.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-65",
    cx: 586.61,
    cy: 332.21,
    r: 5.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m580.72,332.21c0,3.25,2.64,5.89,5.89,5.89,3.25,0,5.89-2.64,5.89-5.89,0-3.25-2.64-2.75-5.89-2.75-3.25,0-5.89-.5-5.89,2.75Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 559.9,
    cy: 346.93,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m573.96,321.7s-3.32,2.56-11.47,3.75c-8.15,1.19-12.38,4.29-12.88,8.32s1.92,4.68,7.75,3.13,7.65-8.87,11.17-10.57c3.52-1.7,5.63-3.23,5.43-4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m536.77,355.77c1.68-2.97,4.26-9.95,4.89-11.67l-.19-2.18,7.25-12.24v-1.84s7.06-3.9,18.34-12.15c11.28-8.25,20.7-18.64,20.7-18.64,0,0,3.61-1.01,7.84,1.71,4.23,2.72,5.99,7.24,5.99,7.24l.07.78c3.23,4.16,5.46,10.75,6.53,18.66.25,1.86.39,3.74.42,5.59v.02c.01.44,0,.86,0,1.28,0,.31,0,.62-.01.93-.28,17.15-3.79,18.42-3.79,18.42,0,0-.84-.23-3.23-1.37-2.39-1.14-6.82-2.77-28.87.93-22.04,3.7-35.43,6.88-35.43,6.88,0,0-2.44,1.04-.52-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m347.12,355.77c-1.68-2.97-4.26-9.95-4.89-11.67l.19-2.18-7.25-12.24v-1.84s-7.06-3.9-18.34-12.15c-11.28-8.25-20.7-18.64-20.7-18.64,0,0-3.61-1.01-7.84,1.71-4.23,2.72-5.99,7.24-5.99,7.24l-.07.78c-3.23,4.16-5.46,10.75-6.53,18.66-.25,1.86-.39,3.74-.42,5.59v.02c-.01.44,0,.86,0,1.28,0,.31,0,.62.01.93.28,17.15,3.79,18.42,3.79,18.42,0,0,.84-.23,3.23-1.37,2.39-1.14,6.82-2.77,28.87.93,22.04,3.7,35.43,6.88,35.43,6.88,0,0,2.44,1.04.52-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m282.31,306.01s1.76-4.53,5.99-7.24c4.23-2.72,7.84-1.71,7.84-1.71,0,0,9.42,10.39,20.7,18.64,11.28,8.25,18.34,12.15,18.34,12.15v1.84l7.25,12.24-.8,9.06-61.98-16.29,2.67-28.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m275.27,331.07c0,19.26,3.81,20.64,3.81,20.64,0,0,.84-.23,3.23-1.37,2.39-1.14,6.82-2.77,28.87.93,22.04,3.7,35.43,6.88,35.43,6.88,0,0,2.44,1.04.52-2.37-1.92-3.4-5.03-12.06-5.03-12.06,0,0-19.23-3.7-24.11-8.51-4.88-4.81-13.23-14.57-20.7-17.75-7.48-3.18-14.06-6.36-14.06-6.36l-7.94,19.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m285,304.01c-4.74,3.52-7.94,11.43-9.29,21.43-1.36,10.01.68,20.4,3.38,24.88-1.62-23.04,3.06-37.89,8.04-36.58,4.98,1.31.26-1.25-1.34-3.57-1.6-2.32-.78-6.16-.78-6.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m300.51,323.58s-5.76-1.66-8.71-1.87-9.58,4.1-10.01,4.47-.65,6.32,3.02,11.23c3.67,4.9,6.48,5.48,10.51,5.55,4.03.07,7.49-1.01,12.17-3.38,4.68-2.38,6.91-3.6,6.91-3.6l-13.9-12.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m301.8,325.09s-5.08-1.46-7.68-1.65c-2.6-.19-8.44,3.62-8.82,3.93-.38.32-.57,5.57,2.67,9.89s5.71,4.83,9.27,4.89c3.55.06,6.6-.89,10.73-2.98,4.13-2.09,6.09-3.17,6.09-3.17l-12.25-10.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m285,304.01s-.72,4.68,3.59,7.43c4.3,2.75,13.51,7.29,15.9,8.49,2.39,1.2,5.86,4.66,9.32,8.13s7.77,8.25,7.77,8.25l18.88,5.38v2.99l-22.11-6.21s-8.01-8.61-12.31-13.03c-4.3-4.42-16.49-11.23-19.84-11.95-3.35-.72-1.2-9.46-1.2-9.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "314.91 337.4 300.33 344.67 279.08 341.8 279.43 344.02 300.39 346.93 316.84 339.25 314.91 337.4"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-49",
    cx: 297.28,
    cy: 332.21,
    r: 6.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-65",
    cx: 297.28,
    cy: 332.21,
    r: 5.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m303.17,332.21c0,3.25-2.64,5.89-5.89,5.89s-5.89-2.64-5.89-5.89,2.64-2.75,5.89-2.75,5.89-.5,5.89,2.75Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 323.99,
    cy: 346.93,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m309.93,321.7s3.32,2.56,11.47,3.75c8.15,1.19,12.38,4.29,12.88,8.32s-1.92,4.68-7.75,3.13c-5.82-1.55-7.65-8.87-11.17-10.57-3.52-1.7-5.63-3.23-5.43-4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m347.12,355.77c-1.68-2.97-4.26-9.95-4.89-11.67l.19-2.18-7.25-12.24v-1.84s-7.06-3.9-18.34-12.15c-11.28-8.25-20.7-18.64-20.7-18.64,0,0-3.61-1.01-7.84,1.71-4.23,2.72-5.99,7.24-5.99,7.24l-.07.78c-3.23,4.16-5.46,10.75-6.53,18.66-.25,1.86-.39,3.74-.42,5.59v.02c-.01.44,0,.86,0,1.28,0,.31,0,.62.01.93.28,17.15,3.79,18.42,3.79,18.42,0,0,.84-.23,3.23-1.37,2.39-1.14,6.82-2.77,28.87.93,22.04,3.7,35.43,6.88,35.43,6.88,0,0,2.44,1.04.52-2.37Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHybridCarLandingImg);
export default __webpack_public_path__ + "static/media/hybrid-car-landing-img.bbe4a6856c43398c91301cff94480874.svg";
export { ForwardRef as ReactComponent };